import React from 'react';

const VisionSVG = () => (
  <svg
    className="prefix__animated"
    id="prefix__freepik_stories-light-bulb"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
  >
    <style>
      {
        "@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes zoomIn{0%{opacity:0;transform:scale(.5)}to{opacity:1;transform:scale(1)}}@keyframes slideLeft{0%{opacity:0;transform:translateX(-30px)}to{opacity:1;transform:translateX(0)}}@keyframes lightSpeedLeft{60%{transform:skewX(-10deg);opacity:1}80%{transform:skewX(2deg)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}svg#prefix__freepik_stories-light-bulb:not(.prefix__animated) .prefix__animable{opacity:0}svg#prefix__freepik_stories-light-bulb.prefix__animated #prefix__freepik--speech-bubble--inject-203{animation:1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown;animation-delay:0s}"
      }
    </style>
    <g
      id="prefix__freepik--Floor--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "255.004px 379.274px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
        animationDelay: "0s",
      }}
    >
      <path
        id="prefix__freepik--floor--inject-203"
        d="M126.54 453.45c-70.95-41-70.95-107.38 0-148.34s186-41 256.92 0 71 107.37 0 148.34-185.98 40.96-256.92 0z"
        style={{
          transformOrigin: "255.004px 379.274px",
        }}
        className="prefix__animable"
        fill="#fafafa"
      />
    </g>
    <g
      id="prefix__freepik--Window--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "91.48px 111.935px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--window--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "91.48px 111.935px",
        }}
      >
        <path
          style={{
            transformOrigin: "91.5px 111.925px",
          }}
          id="prefix__elj5bq0yoexsm"
          className="prefix__animable"
          fill="#fff"
          d="M146.43 125.99L36.57 189.45v-91.6L146.43 34.4v91.59z"
        />
        <path
          style={{
            transformOrigin: "91.5px 159.345px",
          }}
          id="prefix__ele7mqqppvit9"
          className="prefix__animable"
          fill="#fafafa"
          d="M33.81 191.05l2.76 1.65 112.62-65.07-2.76-1.64-112.62 65.06z"
        />
        <path
          d="M154.39 23.76l-123 71.08v106.87l123-71.07zm-5.21 103.87L36.57 192.7V97.85l112.62-65.07z"
          style={{
            transformOrigin: "92.89px 112.735px",
          }}
          id="prefix__elvszjgxt2xmk"
          className="prefix__animable"
          fill="#f0f0f0"
        />
        <path
          style={{
            transformOrigin: "147.81px 80.205px",
          }}
          id="prefix__ellhod4ou1fvh"
          className="prefix__animable"
          fill="#e0e0e0"
          d="M149.19 127.63l-2.76-1.64V34.4l2.76-1.62v94.85z"
        />
        <path
          style={{
            transformOrigin: "91.48px 58.5px",
          }}
          id="prefix__el7otmp6x2lw5"
          className="prefix__animable"
          fill="#fafafa"
          d="M154.39 23.76l-2.8-1.6L28.57 93.24l2.8 1.6 123.02-71.08z"
        />
        <path
          style={{
            transformOrigin: "29.97px 147.475px",
          }}
          id="prefix__elgtnuomyd0hd"
          className="prefix__animable"
          fill="#e0e0e0"
          d="M28.57 93.24l2.8 1.6v106.87l-2.8-1.6V93.24z"
        />
        <path
          style={{
            transformOrigin: "94.03px 88.055px",
          }}
          id="prefix__el65twjfenxf"
          className="prefix__animable"
          fill="#fafafa"
          d="M38.87 117.56v3.24l110.32-63.84-2.76-1.65-107.56 62.25z"
        />
        <path
          style={{
            transformOrigin: "88.875px 114.22px",
          }}
          id="prefix__elt5nf0og0tvm"
          className="prefix__animable"
          fill="#e0e0e0"
          d="M87.47 68.41l2.81-1.62v94.86l-2.81-1.6V68.41z"
        />
        <path
          style={{
            transformOrigin: "92.88px 112.725px",
          }}
          id="prefix__el6ipr8ydhyvx"
          className="prefix__animable"
          fill="#f0f0f0"
          d="M95.48 63.8l-5.2 2.99v94.86l5.2-3.01V63.8z"
        />
        <path
          style={{
            transformOrigin: "92.855px 92.665px",
          }}
          id="prefix__elegxmkj5glfv"
          className="prefix__animable"
          fill="#f0f0f0"
          d="M149.19 56.96v6L36.52 128.37v-6.01l112.67-65.4z"
        />
        <path
          style={{
            transformOrigin: "63.425px 105.895px",
          }}
          id="prefix__elrmf09zjaks"
          className="prefix__animable"
          fill="#fafafa"
          d="M90.28 91.15l-2.81-1.72-50.9 29.46v3.47l53.71-31.21z"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Pictures--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "423.85px 77.115px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--pictures--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "423.85px 77.115px",
        }}
      >
        <g
          id="prefix__freepik--Picture--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "447.62px 100.72px",
          }}
        >
          <g
            id="prefix__freepik--Frame--inject-203"
            className="prefix__animable"
            style={{
              transformOrigin: "447.62px 100.72px",
            }}
          >
            <path
              style={{
                transformOrigin: "447.615px 117.41px",
              }}
              id="prefix__el08hebspragqx"
              className="prefix__animable"
              fill="#fafafa"
              d="M464.24 126.1l-1.55.92-31.7-18.3 1.54-.92 31.71 18.3z"
            />
            <path
              style={{
                transformOrigin: "447.61px 100.72px",
              }}
              id="prefix__el8qdxqu0e7e5"
              className="prefix__animable"
              fill="#fff"
              d="M432.53 107.8l30.16 17.41V93.63l-30.16-17.4v31.57z"
            />
            <path
              d="M428.07 110.4l37.54 21.67V91.94l-37.54-21.67zM431 75.32l31.7 18.31V127L431 108.72z"
              style={{
                transformOrigin: "446.84px 101.17px",
              }}
              id="prefix__elzdvpf5dm4qe"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <path
              style={{
                transformOrigin: "431.76px 92.02px",
              }}
              id="prefix__eldjijy0ds4h"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M430.99 108.72l1.54-.92V76.23l-1.54-.91v33.4z"
            />
            <path
              style={{
                transformOrigin: "447.62px 80.655px",
              }}
              id="prefix__el5mee00f2ihx"
              className="prefix__animable"
              fill="#fafafa"
              d="M428.07 70.27l1.57-.9 37.53 21.67-1.56.9-37.54-21.67z"
            />
            <path
              style={{
                transformOrigin: "466.39px 111.555px",
              }}
              id="prefix__eli3pfkn23tzk"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M467.17 91.04l-1.56.9v40.13l1.56-.89V91.04z"
            />
          </g>
          <g
            id="prefix__freepik--Land--inject-203"
            className="prefix__animable"
            style={{
              transformOrigin: "447.61px 105.975px",
            }}
          >
            <path
              style={{
                transformOrigin: "447.61px 105.975px",
              }}
              id="prefix__el1348i6pt8k9"
              className="prefix__animable"
              fill="#f0f0f0"
              d="M433.71 106.85l27.8 16.06v-8.03l-6.95-16.05-4.33 4.01 1.56 6.73-9.6-20.53-8.48 9.79v8.02z"
            />
            <path
              d="M450.49 91.08a4.53 4.53 0 012.06 3.56c0 1.31-.92 1.84-2.06 1.19a4.56 4.56 0 01-2.05-3.57c0-1.26.92-1.84 2.05-1.18z"
              style={{
                transformOrigin: "450.495px 93.4562px",
              }}
              id="prefix__elal7cdjpbfn7"
              className="prefix__animable"
              fill="#f0f0f0"
            />
          </g>
        </g>
        <g
          id="prefix__freepik--picture--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "400.08px 53.51px",
          }}
        >
          <g
            id="prefix__freepik--frame--inject-203"
            className="prefix__animable"
            style={{
              transformOrigin: "400.08px 53.51px",
            }}
          >
            <path
              style={{
                transformOrigin: "400.065px 70.195px",
              }}
              id="prefix__elihofsxru0o"
              className="prefix__animable"
              fill="#fafafa"
              d="M416.69 78.89l-1.54.92-31.71-18.3 1.55-.93 31.7 18.31z"
            />
            <path
              style={{
                transformOrigin: "400.07px 53.5px",
              }}
              id="prefix__elf4b7yp1gr97"
              className="prefix__animable"
              fill="#fff"
              d="M384.99 60.58l30.16 17.41V46.41l-30.16-17.4v31.57z"
            />
            <path
              d="M380.53 63.19l37.53 21.67V44.73l-37.53-21.67zm2.91-35.08l31.71 18.3v33.4l-31.71-18.3z"
              style={{
                transformOrigin: "399.295px 53.96px",
              }}
              id="prefix__eleoxigc11m5d"
              className="prefix__animable"
              fill="#f0f0f0"
            />
            <path
              style={{
                transformOrigin: "384.215px 44.81px",
              }}
              id="prefix__el1fhg2b7qf8wj"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M383.44 61.51l1.55-.93V29.01l-1.55-.9v33.4z"
            />
            <path
              style={{
                transformOrigin: "400.08px 33.445px",
              }}
              id="prefix__elwdwgj91ke2"
              className="prefix__animable"
              fill="#fafafa"
              d="M380.53 23.06l1.57-.9 37.53 21.67-1.57.9-37.53-21.67z"
            />
            <path
              style={{
                transformOrigin: "418.845px 64.345px",
              }}
              id="prefix__el7toa3ptjbns"
              className="prefix__animable"
              fill="#e0e0e0"
              d="M419.63 43.83l-1.57.9v40.13l1.57-.9V43.83z"
            />
          </g>
          <g
            id="prefix__freepik--land--inject-203"
            className="prefix__animable"
            style={{
              transformOrigin: "400.07px 58.755px",
            }}
          >
            <path
              style={{
                transformOrigin: "400.07px 58.755px",
              }}
              id="prefix__eleifrekxsj99"
              className="prefix__animable"
              fill="#f0f0f0"
              d="M386.17 59.64l27.8 16.05v-8.02l-6.95-16.06-4.33 4.02 1.56 6.72-9.61-20.53-8.47 9.79v8.03z"
            />
            <path
              d="M403 43.86a4.56 4.56 0 012 3.57c0 1.31-.92 1.84-2.05 1.18a4.53 4.53 0 01-2.06-3.56c0-1.31.92-1.84 2.11-1.19z"
              style={{
                transformOrigin: "402.945px 46.2382px",
              }}
              id="prefix__elwxq25h3uu7m"
              className="prefix__animable"
              fill="#f0f0f0"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--Shadows--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "162.779px 419.102px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideLeft",
        animationDelay: "0s",
      }}
    >
      <path
        id="prefix__freepik--Shadow--inject-203"
        d="M237.16 456.92c-14.28-8.24-14.28-21.6 0-29.84s37.41-8.24 51.68 0 14.28 21.6 0 29.84-37.41 8.24-51.68 0z"
        style={{
          transformOrigin: "262.998px 442px",
        }}
        className="prefix__animable"
        fill="#f0f0f0"
      />
      <path
        id="prefix__freepik--shadow--inject-203"
        d="M43.57 434.18c-23.41-13.52-23.41-35.43 0-48.94s61.36-13.52 84.76 0 23.41 35.42 0 48.94-61.33 13.51-84.76 0z"
        style={{
          transformOrigin: "85.9481px 409.71px",
        }}
        className="prefix__animable"
        fill="#f0f0f0"
      />
    </g>
    <g
      id="prefix__freepik--Gears--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "413.4px 396.086px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedLeft",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--Gear--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "434.715px 385.241px",
        }}
      >
        <path
          d="M407 379.61a.85.85 0 00.51.74l1.95 1 1.14-.19a2 2 0 001.47-1.43 10.16 10.16 0 01.45-1.23 1.28 1.28 0 00-.54-1.69l-4.54-2.35a.84.84 0 01-.52-.71zm16.64-2c-2.64 2.22-3 5-1.35 7.38a8.55 8.55 0 011.42-1.51c4.19-3.52 12.55-4.3 18.68-1.75a10.76 10.76 0 014.84 3.58c2.27-3.3.37-7.26-4.91-9.46-6.15-2.5-14.51-1.71-18.7 1.8zm-20 11.43a1.12 1.12 0 000 .36l1 3.17a1.77 1.77 0 001.63 1.18l6.44-.19a2.67 2.67 0 011 .21 2.26 2.26 0 01.56.28l2.2-2.37a1.12 1.12 0 00-.18-1.67 15.22 15.22 0 01-1.55-1.41 3.49 3.49 0 00-1.09-.71 2.56 2.56 0 00-1-.22l-6.43.2a1.79 1.79 0 01-1.63-1.18l-1-3.17a1.06 1.06 0 01-.06-.34zm52-19.49a.87.87 0 01-.26.51l-2.52 2.72a1.11 1.11 0 00.18 1.67 15 15 0 011.55 1.41 2.66 2.66 0 00.54.42l.32-.36a.89.89 0 00.26-.63zM413.81 401a.88.88 0 00.1.35 1 1 0 00.49.41l5.66 2.35a1.13 1.13 0 00.24.08h.19a3.11 3.11 0 00.86 0h.18a2.12 2.12 0 00.72-.27l3.76-2.51a3.52 3.52 0 012.27-.43c1.2.23 2.42.39 3.64.5a2.44 2.44 0 011.23.53 1.54 1.54 0 01.32.3.65.65 0 01.13.16.91.91 0 01.16.24l1.43 2.78v.06a.8.8 0 00.15.21.9.9 0 00.16.18 1.93 1.93 0 00.21.17 2.3 2.3 0 00.46.25 1.84 1.84 0 00.79.12l7-.66a1.19 1.19 0 001.09-1.2l-.05-4a1.57 1.57 0 01.72-.5 28.76 28.76 0 002.92-1.06 3.76 3.76 0 012.32-.13h.07l5.43 1.79a1.37 1.37 0 00.29.07h.05a1.16 1.16 0 00.32 0 2.4 2.4 0 001.49-.49l3.55-3a.87.87 0 00.35-.64l-.07-5.84a.87.87 0 01-.35.61l-3.55 3a2.17 2.17 0 01-.79.39 2.46 2.46 0 01-1.37 0l-5.38-1.75h-.06a3.86 3.86 0 00-2.33.13 26.54 26.54 0 01-2.92 1.06 1.53 1.53 0 00-1 1.6l.36 2.71a1.21 1.21 0 01-1.08 1.38l-7 .66a1.73 1.73 0 01-.79-.13 2 2 0 01-1-.89l-1.43-2.79a2.28 2.28 0 00-.6-.69 2.47 2.47 0 00-1.24-.53c-1.22-.11-2.44-.27-3.64-.5a3.53 3.53 0 00-2.27.44l-3.75 2.5a2 2 0 01-.73.28 2.59 2.59 0 01-1.47-.08l-5.65-2.35a.85.85 0 01-.6-.77zm45-17.58a2.07 2.07 0 00-1.48 1.44 7.19 7.19 0 01-.45 1.22 1.28 1.28 0 00.54 1.69l2.59 1.34 5-.8a1 1 0 00.89-1l-.07-5.88a1 1 0 01-.9 1z"
          style={{
            transformOrigin: "434.715px 388.017px",
          }}
          id="prefix__elq6y066z91oi"
          className="prefix__animable"
          fill="#e6e6e6"
        />
        <g id="prefix__el2pbgazm7sng">
          <path
            d="M407 379.61a.85.85 0 00.51.74l1.95 1 1.14-.19a2 2 0 001.47-1.43 10.16 10.16 0 01.45-1.23 1.28 1.28 0 00-.54-1.69l-4.54-2.35a.84.84 0 01-.52-.71zm16.64-2c-2.64 2.22-3 5-1.35 7.38a8.55 8.55 0 011.42-1.51c4.19-3.52 12.55-4.3 18.68-1.75a10.76 10.76 0 014.84 3.58c2.27-3.3.37-7.26-4.91-9.46-6.15-2.5-14.51-1.71-18.7 1.8zm-20 11.43a1.12 1.12 0 000 .36l1 3.17a1.77 1.77 0 001.63 1.18l6.44-.19a2.67 2.67 0 011 .21 2.26 2.26 0 01.56.28l2.2-2.37a1.12 1.12 0 00-.18-1.67 15.22 15.22 0 01-1.55-1.41 3.49 3.49 0 00-1.09-.71 2.56 2.56 0 00-1-.22l-6.43.2a1.79 1.79 0 01-1.63-1.18l-1-3.17a1.06 1.06 0 01-.06-.34zm52-19.49a.87.87 0 01-.26.51l-2.52 2.72a1.11 1.11 0 00.18 1.67 15 15 0 011.55 1.41 2.66 2.66 0 00.54.42l.32-.36a.89.89 0 00.26-.63zM413.81 401a.88.88 0 00.1.35 1 1 0 00.49.41l5.66 2.35a1.13 1.13 0 00.24.08h.19a3.11 3.11 0 00.86 0h.18a2.12 2.12 0 00.72-.27l3.76-2.51a3.52 3.52 0 012.27-.43c1.2.23 2.42.39 3.64.5a2.44 2.44 0 011.23.53 1.54 1.54 0 01.32.3.65.65 0 01.13.16.91.91 0 01.16.24l1.43 2.78v.06a.8.8 0 00.15.21.9.9 0 00.16.18 1.93 1.93 0 00.21.17 2.3 2.3 0 00.46.25 1.84 1.84 0 00.79.12l7-.66a1.19 1.19 0 001.09-1.2l-.05-4a1.57 1.57 0 01.72-.5 28.76 28.76 0 002.92-1.06 3.76 3.76 0 012.32-.13h.07l5.43 1.79a1.37 1.37 0 00.29.07h.05a1.16 1.16 0 00.32 0 2.4 2.4 0 001.49-.49l3.55-3a.87.87 0 00.35-.64l-.07-5.84a.87.87 0 01-.35.61l-3.55 3a2.17 2.17 0 01-.79.39 2.46 2.46 0 01-1.37 0l-5.38-1.75h-.06a3.86 3.86 0 00-2.33.13 26.54 26.54 0 01-2.92 1.06 1.53 1.53 0 00-1 1.6l.36 2.71a1.21 1.21 0 01-1.08 1.38l-7 .66a1.73 1.73 0 01-.79-.13 2 2 0 01-1-.89l-1.43-2.79a2.28 2.28 0 00-.6-.69 2.47 2.47 0 00-1.24-.53c-1.22-.11-2.44-.27-3.64-.5a3.53 3.53 0 00-2.27.44l-3.75 2.5a2 2 0 01-.73.28 2.59 2.59 0 01-1.47-.08l-5.65-2.35a.85.85 0 01-.6-.77zm45-17.58a2.07 2.07 0 00-1.48 1.44 7.19 7.19 0 01-.45 1.22 1.28 1.28 0 00.54 1.69l2.59 1.34 5-.8a1 1 0 00.89-1l-.07-5.88a1 1 0 01-.9 1z"
            style={{
              transformOrigin: "434.715px 388.017px",
            }}
            className="prefix__animable"
            id="prefix__elklf8ab71z5"
            opacity={0.1}
          />
        </g>
        <path
          d="M451 393.07l5.42 1.78a2.46 2.46 0 001.37 0l.07 5.86a3.29 3.29 0 01-.7.11 1.16 1.16 0 01-.32 0h-.05a1.37 1.37 0 01-.29-.07l-5.43-1.79z"
          style={{
            transformOrigin: "454.43px 396.951px",
          }}
          id="prefix__elsub5el6ptnq"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M433.09 396.08a2.28 2.28 0 01.6.69l1.43 2.79a2 2 0 001 .89l.07 5.87a2.3 2.3 0 01-.46-.25 1.93 1.93 0 01-.21-.17.9.9 0 01-.16-.18.8.8 0 01-.15-.21v-.06l-1.43-2.78a.91.91 0 00-.16-.24 1.83 1.83 0 00-.13-.16 2.21 2.21 0 00-.32-.28z"
          style={{
            transformOrigin: "434.64px 401.2px",
          }}
          id="prefix__el1br566cwaph"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M406.91 373.75a.82.82 0 00.52.71l4.54 2.35a1.28 1.28 0 01.54 1.69 7.29 7.29 0 00-.45 1.23 2 2 0 01-1.48 1.43l-1.13.18-1.95-1a.88.88 0 01-.52-.74z"
          style={{
            transformOrigin: "409.776px 377.545px",
          }}
          id="prefix__eln8rfe7d3idh"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M403.58 383.22a1.06 1.06 0 00.06.34l1 3.17a1.79 1.79 0 001.63 1.18l6.43-.2a2.56 2.56 0 011 .22l.06 5.87a2.67 2.67 0 00-1-.21l-6.44.19a1.77 1.77 0 01-1.63-1.18l-1-3.17a1.12 1.12 0 010-.36z"
          style={{
            transformOrigin: "408.67px 388.51px",
          }}
          id="prefix__elt2coykijir"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M413.74 395.07a.85.85 0 00.6.77l5.65 2.35a2.59 2.59 0 001.47.08l.07 5.86h-.18a3.11 3.11 0 01-.86 0h-.19a1.13 1.13 0 01-.24-.08l-5.66-2.35a1 1 0 01-.49-.41.88.88 0 01-.1-.35z"
          style={{
            transformOrigin: "417.635px 399.615px",
          }}
          id="prefix__elth0lv3xx6a"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M410.81 370.09l-3.55 3a.77.77 0 00.17 1.38l4.54 2.35a1.28 1.28 0 01.54 1.69 7.29 7.29 0 00-.45 1.23 2 2 0 01-1.48 1.43l-6.1 1a1 1 0 00-.84 1.41l1 3.17a1.77 1.77 0 001.64 1.17l6.42-.18a3.18 3.18 0 012.09.92 16.51 16.51 0 001.56 1.41 1.11 1.11 0 01.17 1.67l-2.52 2.7a.82.82 0 00.32 1.4l5.66 2.35a2.61 2.61 0 002.2-.2l3.75-2.51a3.51 3.51 0 012.27-.43c1.2.23 2.42.39 3.64.5a2.53 2.53 0 011.84 1.23l1.43 2.78a2 2 0 001.83 1l7-.66a1.21 1.21 0 001.08-1.38l-.36-2.71a1.52 1.52 0 011-1.6 28.76 28.76 0 002.92-1.06A3.83 3.83 0 01451 393l5.5 1.81a2.53 2.53 0 002.15-.41l3.55-3a.77.77 0 00-.17-1.38l-4.54-2.35a1.28 1.28 0 01-.54-1.69 7.19 7.19 0 00.45-1.22 2.05 2.05 0 011.48-1.44l6.1-1a1.06 1.06 0 00.84-1.42l-1-3.16a1.78 1.78 0 00-1.64-1.18l-6.42.19a3.23 3.23 0 01-2.09-.92 15.25 15.25 0 00-1.56-1.41 1.11 1.11 0 01-.17-1.67l2.52-2.73a.82.82 0 00-.33-1.4l-5.65-2.35a2.65 2.65 0 00-2.2.21l-3.75 2.5a3.51 3.51 0 01-2.27.43c-1.2-.22-2.42-.39-3.65-.5a2.55 2.55 0 01-1.83-1.22l-1.47-2.69a2 2 0 00-1.83-1l-7 .66a1.2 1.2 0 00-1.08 1.38l.36 2.71a1.5 1.5 0 01-1 1.59 28.79 28.79 0 00-2.92 1.07 3.76 3.76 0 01-2.32.12l-5.5-1.8a2.5 2.5 0 00-2.21.36zm31.49 5.81c6.13 2.54 7.7 7.46 3.51 11s-12.55 4.31-18.68 1.76-7.7-7.47-3.51-11 12.55-4.31 18.68-1.76z"
          style={{
            transformOrigin: "434.719px 382.28px",
          }}
          id="prefix__elsvhz8acc4yp"
          className="prefix__animable"
          fill="#ebebeb"
        />
      </g>
      <g
        id="prefix__freepik--gear--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "385.79px 411.261px",
        }}
      >
        <path
          d="M363.61 406.82a.68.68 0 00.41.59l1.55.8.91-.15a1.62 1.62 0 001.18-1.14 7.67 7.67 0 01.35-1 1 1 0 00-.43-1.34l-3.58-1.86a.66.66 0 01-.41-.56zm13.27-1.55c-2.1 1.77-2.39 4-1.08 5.88a6.66 6.66 0 011.14-1.21c3.33-2.8 10-3.42 14.89-1.39a8.62 8.62 0 013.86 2.85c1.8-2.63.29-5.79-3.92-7.54-4.88-2.03-11.55-1.4-14.89 1.41zm-15.88 9.1a1 1 0 00.05.29l.8 2.52a1.4 1.4 0 001.3.94l5.13-.15a1.94 1.94 0 01.79.17 2.58 2.58 0 01.44.22l1.75-1.89a.89.89 0 00-.14-1.33 13.6 13.6 0 01-1.24-1.12 2.64 2.64 0 00-.86-.57 2 2 0 00-.8-.17l-5.13.15a1.42 1.42 0 01-1.31-.94L361 410a1 1 0 01-.05-.27zm41.48-15.53a.68.68 0 01-.21.4l-2 2.17a.89.89 0 00.14 1.33 12.35 12.35 0 011.24 1.13 2.12 2.12 0 00.43.33l.26-.28a.75.75 0 00.21-.51zm-33.38 25a.57.57 0 00.08.28.74.74 0 00.39.32l4.51 1.88a.66.66 0 00.2.06.58.58 0 00.14 0 2.28 2.28 0 00.69 0h.15a1.59 1.59 0 00.58-.21l3-2a2.74 2.74 0 011.8-.34c1 .18 1.93.31 2.91.4a1.78 1.78 0 011 .42 1.53 1.53 0 01.36.37.94.94 0 01.12.18l1.15 2.22a.66.66 0 00.12.17.53.53 0 00.12.14.79.79 0 00.17.14 1.65 1.65 0 00.37.2 1.35 1.35 0 00.62.1l5.6-.53a1 1 0 00.87-.95v-3.18a1.27 1.27 0 01.57-.4 20.67 20.67 0 002.33-.84 3 3 0 011.85-.11h.05l4.33 1.43h.24a1 1 0 00.25 0 1.91 1.91 0 001.19-.39l2.83-2.38a.74.74 0 00.28-.51l-.06-4.66a.72.72 0 01-.27.49l-2.84 2.38a1.58 1.58 0 01-.62.31 1.88 1.88 0 01-1.1 0l-4.32-1.41h-.05a3 3 0 00-1.86.1 23.54 23.54 0 01-2.32.84 1.21 1.21 0 00-.83 1.28l.29 2.16a1 1 0 01-.86 1.1l-5.6.52a1.29 1.29 0 01-.63-.1 1.57 1.57 0 01-.83-.71l-1.14-2.22a1.78 1.78 0 00-.48-.55 2 2 0 00-1-.42c-1-.09-1.95-.22-2.9-.4a2.77 2.77 0 00-1.81.34l-3 2a1.68 1.68 0 01-.58.23 2.12 2.12 0 01-1.18-.07l-4.5-1.87a.69.69 0 01-.48-.61zm35.9-14a1.66 1.66 0 00-1.17 1.15 6.09 6.09 0 01-.36 1 1 1 0 00.43 1.34l2.06 1.07 4-.64a.83.83 0 00.72-.81l-.05-4.69a.84.84 0 01-.72.82z"
          style={{
            transformOrigin: "385.815px 413.507px",
          }}
          id="prefix__elfngfwslw13s"
          className="prefix__animable"
          fill="#e6e6e6"
        />
        <g id="prefix__eltvc4qr4a4e">
          <path
            d="M363.61 406.82a.68.68 0 00.41.59l1.55.8.91-.15a1.62 1.62 0 001.18-1.14 7.67 7.67 0 01.35-1 1 1 0 00-.43-1.34l-3.58-1.86a.66.66 0 01-.41-.56zm13.27-1.55c-2.1 1.77-2.39 4-1.08 5.88a6.66 6.66 0 011.14-1.21c3.33-2.8 10-3.42 14.89-1.39a8.62 8.62 0 013.86 2.85c1.8-2.63.29-5.79-3.92-7.54-4.88-2.03-11.55-1.4-14.89 1.41zm-15.88 9.1a1 1 0 00.05.29l.8 2.52a1.4 1.4 0 001.3.94l5.13-.15a1.94 1.94 0 01.79.17 2.58 2.58 0 01.44.22l1.75-1.89a.89.89 0 00-.14-1.33 13.6 13.6 0 01-1.24-1.12 2.64 2.64 0 00-.86-.57 2 2 0 00-.8-.17l-5.13.15a1.42 1.42 0 01-1.31-.94L361 410a1 1 0 01-.05-.27zm41.48-15.53a.68.68 0 01-.21.4l-2 2.17a.89.89 0 00.14 1.33 12.35 12.35 0 011.24 1.13 2.12 2.12 0 00.43.33l.26-.28a.75.75 0 00.21-.51zm-33.38 25a.57.57 0 00.08.28.74.74 0 00.39.32l4.51 1.88a.66.66 0 00.2.06.58.58 0 00.14 0 2.28 2.28 0 00.69 0h.15a1.59 1.59 0 00.58-.21l3-2a2.74 2.74 0 011.8-.34c1 .18 1.93.31 2.91.4a1.78 1.78 0 011 .42 1.53 1.53 0 01.36.37.94.94 0 01.12.18l1.15 2.22a.66.66 0 00.12.17.53.53 0 00.12.14.79.79 0 00.17.14 1.65 1.65 0 00.37.2 1.35 1.35 0 00.62.1l5.6-.53a1 1 0 00.87-.95v-3.18a1.27 1.27 0 01.57-.4 20.67 20.67 0 002.33-.84 3 3 0 011.85-.11h.05l4.33 1.43h.24a1 1 0 00.25 0 1.91 1.91 0 001.19-.39l2.83-2.38a.74.74 0 00.28-.51l-.06-4.66a.72.72 0 01-.27.49l-2.84 2.38a1.58 1.58 0 01-.62.31 1.88 1.88 0 01-1.1 0l-4.32-1.41h-.05a3 3 0 00-1.86.1 23.54 23.54 0 01-2.32.84 1.21 1.21 0 00-.83 1.28l.29 2.16a1 1 0 01-.86 1.1l-5.6.52a1.29 1.29 0 01-.63-.1 1.57 1.57 0 01-.83-.71l-1.14-2.22a1.78 1.78 0 00-.48-.55 2 2 0 00-1-.42c-1-.09-1.95-.22-2.9-.4a2.77 2.77 0 00-1.81.34l-3 2a1.68 1.68 0 01-.58.23 2.12 2.12 0 01-1.18-.07l-4.5-1.87a.69.69 0 01-.48-.61zm35.9-14a1.66 1.66 0 00-1.17 1.15 6.09 6.09 0 01-.36 1 1 1 0 00.43 1.34l2.06 1.07 4-.64a.83.83 0 00.72-.81l-.05-4.69a.84.84 0 01-.72.82z"
            style={{
              transformOrigin: "385.815px 413.507px",
            }}
            className="prefix__animable"
            id="prefix__elfiyuodjra"
            opacity={0.1}
          />
        </g>
        <path
          d="M398.74 417.56l4.32 1.41a1.88 1.88 0 001.1 0v4.67a2.62 2.62 0 01-.56.09 1 1 0 01-.25 0h-.24l-4.33-1.43z"
          style={{
            transformOrigin: "401.45px 420.649px",
          }}
          id="prefix__el0a1lttqi3gq9"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M384.43 420a1.78 1.78 0 01.48.55l1.14 2.22a1.57 1.57 0 00.83.71l.06 4.68a1.65 1.65 0 01-.37-.2.79.79 0 01-.17-.14.53.53 0 01-.12-.14.66.66 0 01-.12-.17l-1.16-2.32a.94.94 0 00-.12-.18 1.47 1.47 0 00-.1-.13l-.26-.23z"
          style={{
            transformOrigin: "385.685px 424.08px",
          }}
          id="prefix__elqszh8ak84ui"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M363.55 402.16a.68.68 0 00.42.56l3.62 1.88a1 1 0 01.43 1.34 6.46 6.46 0 00-.36 1 1.62 1.62 0 01-1.18 1.15l-.9.14-1.55-.8a.66.66 0 01-.41-.59z"
          style={{
            transformOrigin: "365.839px 405.195px",
          }}
          id="prefix__elavx7o8tn7vm"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M360.9 409.71a1 1 0 00.05.27l.8 2.52a1.42 1.42 0 001.31.94l5.13-.15a2 2 0 01.8.17v4.68a1.94 1.94 0 00-.79-.17l-5.13.15a1.4 1.4 0 01-1.3-.94l-.8-2.52a1 1 0 01-.05-.29z"
          style={{
            transformOrigin: "364.945px 413.925px",
          }}
          id="prefix__elv6wkf1cwi1a"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M369 419.16a.69.69 0 00.48.61l4.5 1.87a2.12 2.12 0 001.18.07l.06 4.67h-.15a2.28 2.28 0 01-.69 0 .58.58 0 01-.14 0 .66.66 0 01-.2-.06l-4.51-1.88a.74.74 0 01-.39-.32.57.57 0 01-.08-.28z"
          style={{
            transformOrigin: "372.11px 422.783px",
          }}
          id="prefix__ell9zcgot4xgf"
          className="prefix__animable"
          fill="#e0e0e0"
        />
        <path
          d="M366.67 399.24l-2.84 2.38a.62.62 0 00.14 1.1l3.62 1.88a1 1 0 01.43 1.34 6.46 6.46 0 00-.36 1 1.61 1.61 0 01-1.17 1.14l-4.87.79A.84.84 0 00361 410l.81 2.52a1.39 1.39 0 001.3.94l5.12-.15a2.51 2.51 0 011.67.74 13.6 13.6 0 001.24 1.12.89.89 0 01.14 1.33l-2 2.17a.66.66 0 00.26 1.12l4.5 1.87a2.12 2.12 0 001.76-.16l3-2a2.77 2.77 0 011.81-.34c.95.18 1.93.31 2.9.4a2 2 0 011.47 1l1.14 2.22a1.61 1.61 0 001.46.81l5.6-.52a1 1 0 00.85-1.1l-.28-2.16a1.21 1.21 0 01.83-1.28 21.23 21.23 0 002.32-.84 3 3 0 011.86-.1l4.38 1.43a2 2 0 001.71-.32l2.84-2.38a.62.62 0 00-.14-1.1l-3.62-1.88a1 1 0 01-.43-1.34 6.09 6.09 0 00.36-1 1.61 1.61 0 011.17-1.14l4.87-.79a.84.84 0 00.67-1.13l-.81-2.52a1.42 1.42 0 00-1.3-.94l-5.12.15a2.55 2.55 0 01-1.67-.73 12.35 12.35 0 00-1.24-1.13.89.89 0 01-.14-1.33l2-2.17a.66.66 0 00-.26-1.12l-4.5-1.87a2.12 2.12 0 00-1.76.16l-3 2a2.77 2.77 0 01-1.81.34c-1-.18-1.93-.31-2.91-.4a2 2 0 01-1.46-1l-1.14-2.22a1.61 1.61 0 00-1.46-.81l-5.6.52a1 1 0 00-.85 1.1l.28 2.16a1.21 1.21 0 01-.83 1.28 23.54 23.54 0 00-2.32.84 3 3 0 01-1.86.1l-4.38-1.43a2 2 0 00-1.76.32zm25.1 4.63c4.89 2 6.14 5.95 2.8 8.75s-10 3.44-14.89 1.4-6.14-5.95-2.8-8.75 10.01-3.44 14.89-1.4z"
          style={{
            transformOrigin: "385.783px 408.97px",
          }}
          id="prefix__el80hks42mj8e"
          className="prefix__animable"
          fill="#ebebeb"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Outlet--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "428.84px 285.465px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedLeft",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--outlet--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "428.84px 285.465px",
        }}
      >
        <path
          style={{
            transformOrigin: "428.84px 255.52px",
          }}
          id="prefix__elcr6je1qud9r"
          className="prefix__animable"
          fill="#0b345a"
          d="M400.5 244.25l47.86 27.63 8.82-5.09-47.87-27.63-8.81 5.09z"
        />
        <g id="prefix__ell8caun3di7c">
          <path
            style={{
              transformOrigin: "428.84px 255.52px",
            }}
            className="prefix__animable"
            id="prefix__elp0lphxa4f1"
            opacity={0.35}
            d="M400.5 244.25l47.86 27.63 8.82-5.09-47.87-27.63-8.81 5.09z"
          />
        </g>
        <path
          style={{
            transformOrigin: "452.77px 299.28px",
          }}
          id="prefix__eldmi2bcm0m6g"
          className="prefix__animable"
          fill="#0b345a"
          d="M448.36 331.77v-59.89l8.82-5.09v59.89l-8.82 5.09z"
        />
        <g id="prefix__elpwy9dskh57j">
          <path
            style={{
              transformOrigin: "452.77px 299.28px",
            }}
            className="prefix__animable"
            id="prefix__elkil42o0faz"
            opacity={0.2}
            d="M448.36 331.77v-59.89l8.82-5.09v59.89l-8.82 5.09z"
          />
        </g>
        <path
          style={{
            transformOrigin: "424.43px 288.01px",
          }}
          id="prefix__elet21itz293c"
          className="prefix__animable"
          fill="#0b345a"
          d="M448.36 331.77l-47.86-27.63v-59.89l47.86 27.63v59.89z"
        />
        <g id="prefix__elwtasdsqxy1p">
          <path
            style={{
              transformOrigin: "424.43px 288.01px",
            }}
            className="prefix__animable"
            id="prefix__el2xdlvicf04j"
            opacity={0.15}
            d="M448.36 331.77l-47.86-27.63v-59.89l47.86 27.63v59.89z"
          />
        </g>
        <g id="prefix__ell646f9y74mb">
          <path
            style={{
              transformOrigin: "424.43px 258.79px",
            }}
            className="prefix__animable"
            id="prefix__eluelmvr39g0i"
            opacity={0.1}
            d="M448.36 271.88l-2.52 1.45-42.83-24.72-2.51-4.36 47.86 27.63z"
          />
        </g>
        <g id="prefix__elnxt33gqtoj">
          <path
            style={{
              transformOrigin: "424.43px 317.23px",
            }}
            className="prefix__animable"
            id="prefix__elrfvo0v64cjk"
            opacity={0.1}
            d="M400.5 304.14l2.52-1.45 42.82 24.72 2.52 4.36-47.86-27.63z"
          />
        </g>
        <path
          style={{
            transformOrigin: "447.1px 301.825px",
          }}
          id="prefix__elvdl1bn0k4u"
          className="prefix__animable"
          fill="#0b345a"
          d="M448.36 331.77l-2.52-4.36v-54.08l2.52-1.45v59.89z"
        />
        <path
          style={{
            transformOrigin: "401.76px 274.195px",
          }}
          id="prefix__elkut79ael07n"
          className="prefix__animable"
          fill="#0b345a"
          d="M400.5 304.14l2.52-1.45-.01-54.08-2.51-4.36v59.89z"
        />
        <path
          d="M434.88 279.86v28.37c0 1.78-1.24 2.5-2.78 1.61L416.76 301a6.16 6.16 0 01-2.79-4.83v-28.39c0-1.77 1.25-2.49 2.79-1.6L432.1 275a6.15 6.15 0 012.78 4.86z"
          style={{
            transformOrigin: "424.425px 288.01px",
          }}
          id="prefix__elz5wvk5n085o"
          className="prefix__animable"
          fill="#37474f"
        />
        <path
          d="M432.1 275l-14.36-8.28v27.08a6.16 6.16 0 002.79 4.82l14.35 8.29v-27.05a6.15 6.15 0 00-2.78-4.86z"
          style={{
            transformOrigin: "426.31px 286.815px",
          }}
          id="prefix__eloq380qdmsz"
          className="prefix__animable"
          fill="#455a64"
        />
        <path
          d="M422.66 272.84l9 5.2a1.18 1.18 0 01.54.93v1.28c0 .34-.24.48-.54.31l-9-5.2a1.18 1.18 0 01-.54-.93v-1.28c.01-.34.25-.48.54-.31z"
          style={{
            transformOrigin: "427.16px 276.7px",
          }}
          id="prefix__elsvw45q7mqp"
          className="prefix__animable"
          fill="#263238"
        />
        <path
          d="M422.65 291.5l9 5.19a1.18 1.18 0 01.54.93v1.28c0 .34-.24.48-.54.31l-9-5.2a1.17 1.17 0 01-.54-.93v-1.27c.01-.35.25-.49.54-.31z"
          style={{
            transformOrigin: "427.15px 295.352px",
          }}
          id="prefix__el5ly891uh6k5"
          className="prefix__animable"
          fill="#263238"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Cable--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "339.334px 362.258px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--cable--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "339.334px 362.258px",
        }}
      >
        <g
          id="prefix__freepik--Plug--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "387.974px 309.52px",
          }}
        >
          <path
            d="M417.17 286.84a2.6 2.6 0 00-1.53-2.12l-2.5-1.45a6.75 6.75 0 00-3.67-.88 6.36 6.36 0 00-3.69.88L385.44 295v2.11l9.87 5.7 20.32-11.73a2.58 2.58 0 001.53-2.12zm-5.1 1.45a4.23 4.23 0 01-.71.32 5.51 5.51 0 01-1.74.27 5.1 5.1 0 01-2.47-.59 2.5 2.5 0 01-.5-.37 2.47 2.47 0 01.5-.36 5.46 5.46 0 014.21-.31 3.25 3.25 0 01.71.31 2.47 2.47 0 01.5.36 2.5 2.5 0 01-.5.37z"
            style={{
              transformOrigin: "401.305px 292.592px",
            }}
            id="prefix__eljesbpmo32dh"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M385.44 295l9.87 5.69L415.64 289a2.23 2.23 0 000-4.24l-2.5-1.45a6.75 6.75 0 00-3.67-.88 6.36 6.36 0 00-3.69.88m5.58 1.86a4.6 4.6 0 01.71.31c1.36.79 1.36 2.06 0 2.85a4.23 4.23 0 01-.71.32 5.51 5.51 0 01-1.74.27 5.1 5.1 0 01-2.47-.59c-1.37-.79-1.37-2.06 0-2.85a5.51 5.51 0 014.21-.35z"
            style={{
              transformOrigin: "401.309px 291.552px",
            }}
            id="prefix__eld4mx95zv0iu"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__eldt6pw615m26">
            <path
              d="M385.44 295l9.87 5.69L415.64 289a2.23 2.23 0 000-4.24l-2.5-1.45a6.75 6.75 0 00-3.67-.88 6.36 6.36 0 00-3.69.88m5.58 1.86a4.6 4.6 0 01.71.31c1.36.79 1.36 2.06 0 2.85a4.23 4.23 0 01-.71.32 5.51 5.51 0 01-1.74.27 5.1 5.1 0 01-2.47-.59c-1.37-.79-1.37-2.06 0-2.85a5.51 5.51 0 014.21-.35z"
              style={{
                transformOrigin: "401.309px 291.552px",
              }}
              className="prefix__animable"
              id="prefix__elcv0budp6ae"
              fill="#fff"
              opacity={0.45}
            />
          </g>
          <g id="prefix__elw1kozh89p3h">
            <path
              d="M415.64 289l-20.32 11.73-9.88-5.73v2.11l9.87 5.69 20.32-11.72a2.58 2.58 0 001.53-2.13v-2.11a2.58 2.58 0 01-1.52 2.16z"
              style={{
                transformOrigin: "401.3px 294.82px",
              }}
              className="prefix__animable"
              id="prefix__elh78lqhls9i"
              fill="#fff"
              opacity={0.15}
            />
          </g>
          <g id="prefix__elev42dd7uget">
            <path
              d="M407.14 288.29a2.73 2.73 0 01-.49-.37 3.3 3.3 0 01.49-.37 5.49 5.49 0 014.22-.3 3.79 3.79 0 01.71.3 2.51 2.51 0 01.49.37c.83-.78.67-1.81-.49-2.48a4.6 4.6 0 00-.71-.31 5.49 5.49 0 00-4.22.31c-1.36.79-1.36 2.06 0 2.85z"
              style={{
                transformOrigin: "409.601px 286.569px",
              }}
              className="prefix__animable"
              id="prefix__eldk9rkk1yyo"
              fill="#fff"
              opacity={0.15}
            />
          </g>
          <path
            d="M417.17 305.43a2.6 2.6 0 00-1.53-2.13l-2.5-1.45a6.84 6.84 0 00-3.67-.88 6.44 6.44 0 00-3.69.88l-20.34 11.73v2.12l9.87 5.69 20.32-11.73a2.58 2.58 0 001.53-2.12zm-5.1 1.44a3.55 3.55 0 01-.71.32 5.51 5.51 0 01-1.74.27 5 5 0 01-2.47-.59 2.47 2.47 0 01-.5-.36 2.5 2.5 0 01.5-.37 5.46 5.46 0 014.21-.31 4.6 4.6 0 01.71.31 2.5 2.5 0 01.5.37 2.47 2.47 0 01-.5.36z"
            style={{
              transformOrigin: "401.305px 311.173px",
            }}
            id="prefix__eljhjeuzcgmeq"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M385.44 313.58l9.87 5.69 20.32-11.72a2.24 2.24 0 000-4.25l-2.5-1.45a6.84 6.84 0 00-3.67-.88 6.44 6.44 0 00-3.69.88m5.58 1.87a3.25 3.25 0 01.71.31c1.36.78 1.36 2.06 0 2.84a3.55 3.55 0 01-.71.32 5.51 5.51 0 01-1.74.27 5 5 0 01-2.47-.59c-1.37-.78-1.37-2.06 0-2.84a5.46 5.46 0 014.22-.31z"
            style={{
              transformOrigin: "401.301px 310.113px",
            }}
            id="prefix__el04y90k8isq3p"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__elrvwbvvz93ce">
            <path
              d="M385.44 313.58l9.87 5.69 20.32-11.72a2.24 2.24 0 000-4.25l-2.5-1.45a6.84 6.84 0 00-3.67-.88 6.44 6.44 0 00-3.69.88m5.58 1.87a3.25 3.25 0 01.71.31c1.36.78 1.36 2.06 0 2.84a3.55 3.55 0 01-.71.32 5.51 5.51 0 01-1.74.27 5 5 0 01-2.47-.59c-1.37-.78-1.37-2.06 0-2.84a5.46 5.46 0 014.22-.31z"
              style={{
                transformOrigin: "401.301px 310.113px",
              }}
              className="prefix__animable"
              id="prefix__eldm5c5qywmom"
              fill="#fff"
              opacity={0.45}
            />
          </g>
          <g id="prefix__elomkloftlatb">
            <path
              d="M415.64 307.55l-20.32 11.73-9.87-5.69v2.11l9.87 5.69 20.32-11.72a2.58 2.58 0 001.53-2.13v-2.11a2.58 2.58 0 01-1.53 2.12z"
              style={{
                transformOrigin: "401.31px 313.41px",
              }}
              className="prefix__animable"
              id="prefix__elgqatw4y51h"
              fill="#fff"
              opacity={0.15}
            />
          </g>
          <g id="prefix__el95t8k62pfln">
            <path
              d="M407.14 306.88a2.73 2.73 0 01-.49-.37 3.3 3.3 0 01.49-.37 5.49 5.49 0 014.22-.3 3.79 3.79 0 01.71.3 2.15 2.15 0 01.49.36c.83-.77.67-1.8-.49-2.47a4.6 4.6 0 00-.71-.31 5.49 5.49 0 00-4.22.31c-1.36.79-1.36 2.06 0 2.85z"
              style={{
                transformOrigin: "409.601px 305.159px",
              }}
              className="prefix__animable"
              id="prefix__eltvwwuh1dshp"
              fill="#fff"
              opacity={0.15}
            />
          </g>
          <path
            d="M402.89 326.07a2.4 2.4 0 001-2.21V298a7.6 7.6 0 00-3.45-6l-13.95-8a2.4 2.4 0 00-2.43-.23c-.57.34-2.65 1.54-3.23 1.87a2.38 2.38 0 00-1 2.22v25.91a7.6 7.6 0 003.45 6l13.95 8a2.41 2.41 0 002.43.25z"
            style={{
              transformOrigin: "391.859px 305.89px",
            }}
            id="prefix__elp2xybvfre7h"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M400.65 299.82v25.9c0 2.2-1.54 3.09-3.44 2l-13.95-8a7.6 7.6 0 01-3.45-6V287.8c0-2.2 1.54-3.09 3.45-2l13.95 8a7.62 7.62 0 013.44 6.02z"
            style={{
              transformOrigin: "390.23px 306.76px",
            }}
            id="prefix__el70yrbh99jnh"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M397.38 297.11v25.8s-19.11 11.42-22.09 12.74a9.74 9.74 0 01-8.66 0l-3.53-2a9.58 9.58 0 01-4.33-7.5V308a9.56 9.56 0 014.33-7.5l20-11.58z"
            style={{
              transformOrigin: "378.075px 312.793px",
            }}
            id="prefix__elpg4kz0e4j"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M360.75 331.45a8.14 8.14 0 002.35 2.17l3.53 2a9.74 9.74 0 008.66 0c3-1.32 22.09-12.74 22.09-12.74v-25.8l-27.51 14.31z"
            style={{
              transformOrigin: "379.065px 316.858px",
            }}
            id="prefix__elidenlq5i9vr"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M363.1 305.48l3.53 2A9.58 9.58 0 01371 315v18.14c0 2.77-1.94 3.88-4.33 2.5l-3.53-2a9.58 9.58 0 01-4.33-7.5V308c-.04-2.79 1.9-3.9 4.29-2.52z"
            style={{
              transformOrigin: "364.905px 320.56px",
            }}
            id="prefix__elzhtckrl5bxi"
            className="prefix__animable"
            fill="#263238"
          />
        </g>
        <path
          d="M272.6 442.14a10.33 10.33 0 01-5.27-1.37c-3.77-2.17-5.84-6.6-5.84-12.48v-124a1.5 1.5 0 013 0v124c0 4.76 1.54 8.27 4.34 9.89s6.6 1.18 10.72-1.2l34.53-20.06c5.51-3.19 10.17-11.27 10.17-17.63v-45.17c0-7.42 5.23-16.49 11.66-20.2l27.38-15.83a1.5 1.5 0 111.5 2.6l-27.38 15.83c-5.51 3.18-10.16 11.24-10.16 17.6v45.17c0 7.43-5.24 16.5-11.67 20.22l-34.52 20.06a17.1 17.1 0 01-8.46 2.57z"
          style={{
            transformOrigin: "313.518px 372.465px",
          }}
          id="prefix__eldsrhr81n5lb"
          className="prefix__animable"
          fill="#455a64"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--light-bulb--inject-203"
      className="prefix__animable prefix__animator-active"
      style={{
        transformOrigin: "263.005px 190.941px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) zoomIn,1.5s Infinite linear floating",
        animationDelay: "0s,1s",
      }}
    >
      <g
        id="prefix__freepik--Bulb--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "263.005px 190.941px",
        }}
      >
        <g
          id="prefix__freepik--Socket--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "263px 288.076px",
          }}
        >
          <g id="prefix__el7g0lp8kuuco">
            <ellipse
              cx={263}
              cy={302.71}
              rx={16.24}
              ry={9.38}
              style={{
                transformOrigin: "263px 302.71px",
              }}
              className="prefix__animable"
              id="prefix__el0d0sbt0yu77q"
              fill="#263238"
              transform="rotate(-.15)"
            />
          </g>
          <path
            d="M278.35 305.74h-2.63a8.06 8.06 0 00-3.39-3.34c-5.16-3-13.52-2.94-18.67 0a8 8 0 00-3.37 3.36h-2.63l3 4.78a8.62 8.62 0 003 2.64c5.16 3 13.52 2.95 18.67 0a8.89 8.89 0 003-2.66z"
            style={{
              transformOrigin: "263.005px 307.792px",
            }}
            id="prefix__eld22epuiz7cp"
            className="prefix__animable"
            fill="#263238"
          />
          <ellipse
            cx={263}
            cy={295.31}
            rx={24.01}
            ry={13.86}
            style={{
              transformOrigin: "263px 295.31px",
            }}
            id="prefix__elljvjibfm4sp"
            className="prefix__animable"
            fill="#455a64"
          />
          <ellipse
            cx={263}
            cy={291.77}
            rx={24.91}
            ry={14.38}
            style={{
              transformOrigin: "263px 291.77px",
            }}
            id="prefix__eld4663t15nwu"
            className="prefix__animable"
            fill="#37474f"
          />
          <ellipse
            cx={263}
            cy={287.97}
            rx={25.54}
            ry={14.74}
            style={{
              transformOrigin: "263px 287.97px",
            }}
            id="prefix__elhrxbxyp7j3r"
            className="prefix__animable"
            fill="#455a64"
          />
          <ellipse
            cx={263}
            cy={284.17}
            rx={26.17}
            ry={15.11}
            style={{
              transformOrigin: "263px 284.17px",
            }}
            id="prefix__el7ayszyz7itc"
            className="prefix__animable"
            fill="#37474f"
          />
          <ellipse
            cx={263}
            cy={280.37}
            rx={26.8}
            ry={15.47}
            style={{
              transformOrigin: "263px 280.37px",
            }}
            id="prefix__el3rhxq9wpv21"
            className="prefix__animable"
            fill="#455a64"
          />
          <ellipse
            cx={263}
            cy={276.57}
            rx={27.43}
            ry={15.83}
            style={{
              transformOrigin: "263px 276.57px",
            }}
            id="prefix__elkfgmsfmnqa"
            className="prefix__animable"
            fill="#37474f"
          />
        </g>
        <path
          d="M291.69 262.4c0-4.24-2.81-8.47-8.41-11.7-11.21-6.48-29.38-6.48-40.59 0-5.6 3.23-8.4 7.47-8.4 11.71v9.76c0 4.24 2.81 8.48 8.42 11.71 11.22 6.46 29.39 6.46 40.59 0 5.6-3.24 8.4-7.48 8.39-11.72 0-1.64.01-8.11 0-9.76z"
          style={{
            transformOrigin: "262.992px 267.283px",
          }}
          id="prefix__elz28yr6ferxc"
          className="prefix__animable"
          fill="#0b345a"
        />
        <path
          d="M263 66.47a86.31 86.31 0 00-86.31 86.31c0 68.53 56.53 79.9 56.53 107.52 0 4.4 2.91 8.8 8.72 12.16 11.63 6.71 30.49 6.71 42.12 0 5.81-3.36 8.72-7.76 8.72-12.16 0-27.62 56.54-39 56.54-107.52A86.32 86.32 0 00263 66.47z"
          style={{
            transformOrigin: "263.005px 171.981px",
          }}
          id="prefix__eloyrnbotkzj"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elutg2831homs">
          <path
            d="M263 66.47a86.31 86.31 0 00-86.31 86.31c0 68.53 56.53 79.9 56.53 107.52 0 4.4 2.91 8.8 8.72 12.16 11.63 6.71 30.49 6.71 42.12 0 5.81-3.36 8.72-7.76 8.72-12.16 0-27.62 56.54-39 56.54-107.52A86.32 86.32 0 00263 66.47z"
            style={{
              mixBlendMode: "screen",
              transformOrigin: "263.005px 171.981px",
            }}
            className="prefix__animable"
            id="prefix__el8im8cni8uie"
            fill="#fff"
            opacity={0.7}
          />
        </g>
        <g id="prefix__elyvj4yl6weg">
          <ellipse
            cx={263}
            cy={260.45}
            rx={24.91}
            ry={14.38}
            style={{
              transformOrigin: "263px 260.45px",
            }}
            className="prefix__animable"
            id="prefix__el1dw0yvh4f9r"
            fill="#0b345a"
            opacity={0.25}
          />
        </g>
        <g id="prefix__elzwsvwc2v8d">
          <path
            d="M284.81 267.41a18.72 18.72 0 01-4.2 3.22c-9.73 5.61-25.5 5.61-35.22 0a18.72 18.72 0 01-4.2-3.22 18.43 18.43 0 014.2-3.22c9.73-5.62 25.5-5.62 35.22 0a18.21 18.21 0 014.2 3.22z"
            style={{
              transformOrigin: "263px 267.406px",
            }}
            className="prefix__animable"
            id="prefix__elvag8ckw7nx"
            fill="#0b345a"
            opacity={0.25}
          />
        </g>
        <g id="prefix__eljobbo8s0qm">
          <path
            d="M284.81 267.41a18.72 18.72 0 01-4.2 3.22c-9.73 5.61-25.5 5.61-35.22 0a18.72 18.72 0 01-4.2-3.22 18.43 18.43 0 014.2-3.22c9.73-5.62 25.5-5.62 35.22 0a18.21 18.21 0 014.2 3.22z"
            style={{
              transformOrigin: "263px 267.406px",
            }}
            className="prefix__animable"
            id="prefix__elx9nu3q22dno"
            fill="#0b345a"
            opacity={0.25}
          />
        </g>
        <g id="prefix__elqjeub5695oj">
          <path
            d="M306.92 101.31a13.75 13.75 0 00-3 1.8c-3.43 2.69-4.82 7.45-4.19 11.77 1.22 8.35 9.26 13.55 13.91 20a74.09 74.09 0 0111.25 23.54c.69 2.51 1.59 6.68 2.88 8.95a6.75 6.75 0 008.59 2.89c3.35-1.78 5.09-6 5.56-9.27 2.8-19.53-1.19-34.14-11-49.17-5.43-8.15-13.92-14.82-24-10.51z"
            style={{
              transformOrigin: "321.189px 135.391px",
            }}
            className="prefix__animable"
            id="prefix__el91hhv0guxzc"
            fill="#fff"
            opacity={0.2}
          />
        </g>
        <g id="prefix__elr81bjg5grag">
          <circle
            cx={262.99}
            cy={136.39}
            r={61.56}
            style={{
              transformOrigin: "262.99px 136.39px",
            }}
            className="prefix__animable"
            id="prefix__eldprd3q8fgtf"
            fill="#fff"
            opacity={0.2}
          />
        </g>
        <g id="prefix__eltpmyuu0oenc">
          <path
            d="M325.52 180.82a9.49 9.49 0 00.9 7.73 5.55 5.55 0 007.58 1.73 8.94 8.94 0 004.1-7.48c-.05-3.16-2.1-6.54-5.61-6.88-3.27-.33-6.09 2.25-6.97 4.9z"
            style={{
              transformOrigin: "331.589px 183.497px",
            }}
            className="prefix__animable"
            id="prefix__el0967ms51j2b"
            fill="#fff"
            opacity={0.2}
          />
        </g>
        <g id="prefix__eli8qeoivps4">
          <path
            d="M245.72 251.57c-1.92-10.94-4.9-16.81-18.37-23.71s-36.78-17.4-46.56-45.55c13 43.18 52.43 54.92 52.43 78 0 4.4 2.91 8.8 8.72 12.16a35.14 35.14 0 008 3.28z"
            style={{
              transformOrigin: "215.365px 229.03px",
            }}
            className="prefix__animable"
            id="prefix__eli1lwxcvx86"
            fill="#0b345a"
            opacity={0.15}
          />
        </g>
        <g id="prefix__el2vemluut9wu">
          <path
            d="M280.28 251.57c1.92-10.94 4.9-16.81 18.38-23.71s36.77-17.4 46.56-45.55c-13 43.18-52.44 54.92-52.44 78 0 4.4-2.91 8.8-8.72 12.16a35.24 35.24 0 01-8 3.28c1.2-6.93 3.03-17.38 4.22-24.18z"
            style={{
              transformOrigin: "310.64px 229.03px",
            }}
            className="prefix__animable"
            id="prefix__elqo29zyfwvse"
            fill="#0b345a"
            opacity={0.15}
          />
        </g>
        <path
          d="M273.08 269.07h-1c0-30.72 1.79-50 6-64.37a60 60 0 014.21-10.78A53.15 53.15 0 01263 182.55a53.15 53.15 0 01-19.28 11.37 60 60 0 014.21 10.78c4.2 14.4 6 33.65 6 64.37h-1c0-30.62-1.78-49.79-5.95-64.09a58.38 58.38 0 00-4.25-10.77 26.43 26.43 0 01-2.86.64c-10 1.68-15.89-1.22-18-4.49A6.53 6.53 0 01222 183a6.64 6.64 0 016.86-2.7c4.36.66 9.84 4.44 14.37 12.77a51.82 51.82 0 0019-11.16 22.38 22.38 0 01-2.86-3.41c-4.71-7.15-4.43-13.32-2.6-16.72a6.92 6.92 0 0112.34 0c1.83 3.4 2.11 9.57-2.6 16.72a22.38 22.38 0 01-2.86 3.41 51.82 51.82 0 0019 11.16c4.53-8.33 10-12.11 14.37-12.77A6.63 6.63 0 01304 183a6.53 6.53 0 01.18 7.41c-2.13 3.27-8 6.17-18 4.49a26.08 26.08 0 01-2.87-.64A58.38 58.38 0 00279 205c-4.15 14.28-5.92 33.45-5.92 64.07zm10.68-75.76c.86.23 1.71.42 2.54.56 9.57 1.59 15.05-1.05 17-4.05a5.5 5.5 0 00-.18-6.32 5.67 5.67 0 00-5.87-2.26c-3.89.59-9.11 4.17-13.49 12.07zm-56.23-12.16a5.36 5.36 0 00-4.68 2.35 5.5 5.5 0 00-.18 6.32c2 3 7.46 5.64 17 4.05.83-.14 1.68-.33 2.55-.56-4.39-7.9-9.61-11.48-13.5-12.07a8.28 8.28 0 00-1.19-.09zM263 158.94a5.85 5.85 0 00-5.29 3.26c-2.12 4-1.12 10.11 2.56 15.7a21.57 21.57 0 002.73 3.27 21.82 21.82 0 002.74-3.28c3.67-5.58 4.68-11.73 2.55-15.69a5.84 5.84 0 00-5.29-3.26z"
          style={{
            transformOrigin: "263.022px 213.532px",
          }}
          id="prefix__elqlyspvs1rp"
          className="prefix__animable"
          fill="#455a64"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Sparkles--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "260.38px 143.595px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--Shine--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "260.38px 143.595px",
        }}
      >
        <g id="prefix__freepik--shine--inject-203">
          <g
            style={{
              transformOrigin: "260.38px 143.595px",
            }}
            className="prefix__animable"
            id="prefix__elk7rpjgyuow8"
            opacity={0.2}
          >
            <path
              d="M262.82 60a.5.5 0 01-.5-.5V11.88a.5.5 0 111 0v47.61a.5.5 0 01-.5.51z"
              style={{
                transformOrigin: "262.82px 35.69px",
              }}
              id="prefix__el3f21m3puezx"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M238.23 63.29a.5.5 0 01-.48-.37l-9.59-35.79a.5.5 0 111-.26l9.59 35.79a.5.5 0 01-.35.61z"
              style={{
                transformOrigin: "233.455px 44.886px",
              }}
              id="prefix__el3cysrcsnhfy"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M215.33 72.84a.5.5 0 01-.43-.25L200 46.84a.5.5 0 01.86-.5l14.87 25.75a.49.49 0 01-.18.68.47.47 0 01-.22.07z"
              style={{
                transformOrigin: "207.878px 59.487px",
              }}
              id="prefix__elm0tmt20gvzc"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M195.68 88a.49.49 0 01-.35-.15l-31.05-31a.5.5 0 010-.71.5.5 0 01.7 0l31.02 31a.5.5 0 010 .71.47.47 0 01-.32.15z"
              style={{
                transformOrigin: "180.14px 71.9985px",
              }}
              id="prefix__elgtf4cuz20eh"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M180.62 107.72a.42.42 0 01-.24-.07L136.1 82.09a.5.5 0 01.5-.87l44.28 25.57a.5.5 0 01-.26.93z"
              style={{
                transformOrigin: "158.487px 94.4367px",
              }}
              id="prefix__elnv9h27or3do"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M171.19 130.67h-.13l-18.59-5a.5.5 0 01.26-1l18.59 5a.51.51 0 01.35.62.5.5 0 01-.48.38z"
              style={{
                transformOrigin: "161.885px 127.662px",
              }}
              id="prefix__el53vjrttklot"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M126.93 156.62a.5.5 0 010-1l41.07-1.35a.5.5 0 010 1l-41.09 1.35z"
              style={{
                transformOrigin: "147.465px 155.445px",
              }}
              id="prefix__el642675eo8cv"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M160.34 182.81a.49.49 0 01-.48-.37.5.5 0 01.35-.62l11-2.94a.5.5 0 01.26 1l-11 2.94z"
              style={{
                transformOrigin: "165.848px 180.842px",
              }}
              id="prefix__elt1dpew7ljb"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M140.06 226.32a.48.48 0 01-.43-.25.5.5 0 01.18-.68l40.8-23.56a.5.5 0 11.5.87l-40.8 23.56a.54.54 0 01-.25.06z"
              style={{
                transformOrigin: "160.463px 214.041px",
              }}
              id="prefix__elmp9worfr4sq"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M164.86 253.57a.47.47 0 01-.35-.15.48.48 0 010-.7l31.15-31.16a.51.51 0 01.71 0 .5.5 0 010 .71l-31.16 31.15a.47.47 0 01-.35.15z"
              style={{
                transformOrigin: "180.438px 237.493px",
              }}
              id="prefix__el1agweln00ps"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M200.21 264.37a.45.45 0 01-.25-.07.49.49 0 01-.18-.68l15.53-26.9a.5.5 0 11.86.5l-15.53 26.9a.5.5 0 01-.43.25z"
              style={{
                transformOrigin: "207.988px 250.398px",
              }}
              id="prefix__elw7gphcn3pwe"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M319.85 252.93a.5.5 0 01-.43-.25L310.36 237a.5.5 0 11.86-.5l9.06 15.7a.5.5 0 01-.18.68.59.59 0 01-.25.05z"
              style={{
                transformOrigin: "315.305px 244.568px",
              }}
              id="prefix__eldzamsjs60pi"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M349.27 240.92a.5.5 0 01-.35-.15l-18.84-18.84a.5.5 0 11.71-.71l18.84 18.84a.51.51 0 010 .71.51.51 0 01-.36.15z"
              style={{
                transformOrigin: "339.853px 230.996px",
              }}
              id="prefix__el51mn0rrhsu2"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M387.36 226.53a.47.47 0 01-.25-.07l-41.87-24.17a.5.5 0 01-.18-.68.51.51 0 01.68-.19l41.87 24.18a.5.5 0 01-.25.93z"
              style={{
                transformOrigin: "366.424px 213.945px",
              }}
              id="prefix__elgg7pwbb3pch"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M374 184.52h-.13l-19.1-5.12a.5.5 0 01.26-1l19.1 5.12a.5.5 0 01.35.61.49.49 0 01-.48.39z"
              style={{
                transformOrigin: "364.44px 181.452px",
              }}
              id="prefix__el0hadc40k70d"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M388.92 154.8h-30.81a.5.5 0 010-1h30.81a.5.5 0 010 1z"
              style={{
                transformOrigin: "373.515px 154.3px",
              }}
              id="prefix__ela1mvung9yq"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M354.81 130.21a.5.5 0 01-.13-1l43.24-11.58a.5.5 0 11.25 1l-43.23 11.59z"
              style={{
                transformOrigin: "376.401px 123.917px",
              }}
              id="prefix__eld62r6vqiv9c"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M345.25 107.31a.5.5 0 01-.43-.25.51.51 0 01.18-.69l47.17-27.23a.5.5 0 01.5.87l-47.17 27.23a.45.45 0 01-.25.07z"
              style={{
                transformOrigin: "368.837px 93.1917px",
              }}
              id="prefix__elp0eyhvk74n"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M330.1 87.66a.47.47 0 01-.35-.15.48.48 0 010-.7l16.64-16.65a.5.5 0 01.71.71l-16.65 16.64a.47.47 0 01-.35.15z"
              style={{
                transformOrigin: "338.422px 78.8373px",
              }}
              id="prefix__elcj94jv2tauq"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M310.38 72.6a.54.54 0 01-.25-.06.52.52 0 01-.19-.69l14.75-25.54a.52.52 0 01.69-.19.51.51 0 01.18.69l-14.75 25.54a.5.5 0 01-.43.25z"
              style={{
                transformOrigin: "317.753px 59.3294px",
              }}
              id="prefix__elbrurwnhbfk7"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M287.43 63.17h-.13a.5.5 0 01-.35-.61l9.41-35.15a.5.5 0 111 .26l-9.45 35.13a.5.5 0 01-.48.37z"
              style={{
                transformOrigin: "292.155px 45.0967px",
              }}
              id="prefix__eln1l65xgoazl"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M259.06 60.07a.5.5 0 01-.5-.48l-1.17-29.5a.49.49 0 01.48-.51.5.5 0 01.5.48l1.17 29.5a.5.5 0 01-.48.52z"
              style={{
                transformOrigin: "258.465px 44.83px",
              }}
              id="prefix__elwd034uj63fc"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M234.62 64.34a.49.49 0 01-.48-.35l-7.08-22.77a.5.5 0 011-.3l7.07 22.78a.49.49 0 01-.32.62.39.39 0 01-.19.02z"
              style={{
                transformOrigin: "231.096px 52.4465px",
              }}
              id="prefix__eluhml5m1mul"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M212.11 74.79a.51.51 0 01-.42-.23l-21-33.22a.51.51 0 01.16-.69.49.49 0 01.69.16l21 33.22a.51.51 0 01-.16.69.52.52 0 01-.27.07z"
              style={{
                transformOrigin: "201.615px 57.68px",
              }}
              id="prefix__elrlysi65l78"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M193.08 90.71a.5.5 0 01-.34-.13l-19.62-18.13a.5.5 0 11.67-.73l19.63 18.13a.49.49 0 010 .7.5.5 0 01-.34.16z"
              style={{
                transformOrigin: "183.236px 81.1247px",
              }}
              id="prefix__elsvc1dzicpgs"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M178.82 111a.53.53 0 01-.24-.06l-16.11-8.47a.51.51 0 01-.21-.68.52.52 0 01.68-.21l16.11 8.48a.5.5 0 01-.23.94z"
              style={{
                transformOrigin: "170.758px 106.264px",
              }}
              id="prefix__elf7rudi1109"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M170.3 134.32h-.12l-51.82-11.72a.5.5 0 01.22-1l51.83 11.71a.5.5 0 01-.11 1z"
              style={{
                transformOrigin: "144.408px 127.954px",
              }}
              id="prefix__elh7w2he4t09f"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M142.94 160a.5.5 0 010-1l25.14-1a.48.48 0 01.52.48.51.51 0 01-.48.52L143 160z"
              style={{
                transformOrigin: "155.52px 158.999px",
              }}
              id="prefix__elfqff24weyjp"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M138.43 194a.5.5 0 01-.48-.35.5.5 0 01.33-.63l33.94-10.55a.5.5 0 01.62.33.51.51 0 01-.33.63L138.57 194z"
              style={{
                transformOrigin: "155.394px 188.225px",
              }}
              id="prefix__el3h3cgmzlk4q"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M139.12 233.57a.5.5 0 01-.26-.92l43.69-27.59a.5.5 0 11.53.85l-43.69 27.58a.45.45 0 01-.27.08z"
              style={{
                transformOrigin: "160.974px 219.277px",
              }}
              id="prefix__els2st1xhmoei"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M186.87 237.87a.48.48 0 01-.34-.14.48.48 0 010-.7l11.87-12.85a.5.5 0 11.73.67l-11.9 12.85a.49.49 0 01-.36.17z"
              style={{
                transformOrigin: "192.845px 230.918px",
              }}
              id="prefix__elesjpdqzbfe"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M329.64 260a.51.51 0 01-.43-.23l-15.63-24.76a.49.49 0 01.16-.69.5.5 0 01.69.15l15.63 24.76a.51.51 0 01-.42.77z"
              style={{
                transformOrigin: "321.816px 247.12px",
              }}
              id="prefix__elc9xgkqi21k"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M367.93 251.6a.51.51 0 01-.34-.14l-34.89-32.23a.5.5 0 010-.71.5.5 0 01.71 0l34.89 32.24a.5.5 0 010 .71.52.52 0 01-.37.13z"
              style={{
                transformOrigin: "350.5px 234.986px",
              }}
              id="prefix__elkys1tdn9oi"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M360 205.74a.46.46 0 01-.23-.06l-12.7-6.68a.5.5 0 01-.21-.68.51.51 0 01.67-.21l12.71 6.69a.49.49 0 01.21.67.5.5 0 01-.45.27z"
              style={{
                transformOrigin: "353.655px 201.899px",
              }}
              id="prefix__elf38o038vo3f"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M393 184.15h-.11l-37.16-8.4a.5.5 0 11.22-1l37.16 8.4a.5.5 0 01-.11 1z"
              style={{
                transformOrigin: "374.442px 179.445px",
              }}
              id="prefix__elk75mzsxi5o"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M358 151a.5.5 0 010-1l44.31-1.76a.48.48 0 01.52.48.5.5 0 01-.49.52L358 151z"
              style={{
                transformOrigin: "380.165px 149.619px",
              }}
              id="prefix__eljfs4dk1ij0k"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M353.75 126.6a.51.51 0 01-.48-.36.5.5 0 01.33-.62l14.74-4.62a.49.49 0 01.63.32.5.5 0 01-.33.63l-14.74 4.58a.4.4 0 01-.15.07z"
              style={{
                transformOrigin: "361.121px 123.786px",
              }}
              id="prefix__elb2fw74ycae4"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M343.3 104.09a.49.49 0 01-.42-.23.5.5 0 01.15-.69l30.21-19.08a.51.51 0 01.69.16.5.5 0 01-.15.69L343.57 104a.45.45 0 01-.27.09z"
              style={{
                transformOrigin: "358.405px 94.0538px",
              }}
              id="prefix__elzl0ve1lcsnj"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M327.38 85.06a.5.5 0 01-.34-.13.51.51 0 010-.71l31.51-34.11a.5.5 0 01.71 0 .49.49 0 010 .7L327.75 84.9a.52.52 0 01-.37.16z"
              style={{
                transformOrigin: "343.152px 67.5111px",
              }}
              id="prefix__elexbv776mmoe"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M307.08 70.8a.53.53 0 01-.24-.06.52.52 0 01-.21-.68l23-43.79a.5.5 0 11.88.47l-23 43.79a.5.5 0 01-.43.27z"
              style={{
                transformOrigin: "318.582px 48.3874px",
              }}
              id="prefix__elyn9qnafjnco"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M283.77 62.27h-.11a.5.5 0 01-.37-.6l2.55-11.32a.5.5 0 011 .22l-2.56 11.32a.49.49 0 01-.51.38z"
              style={{
                transformOrigin: "285.064px 56.1096px",
              }}
              id="prefix__elgyd25vu6oag"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M272.72 60.48h-.05a.5.5 0 01-.44-.55l4.26-40.75a.5.5 0 01.55-.44.5.5 0 01.45.55L273.22 60a.5.5 0 01-.5.48z"
              style={{
                transformOrigin: "274.86px 39.6086px",
              }}
              id="prefix__ellnbxl7h6d4"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M247.92 61.2a.49.49 0 01-.49-.42l-7.5-47.2a.51.51 0 01.42-.57.49.49 0 01.57.41l7.49 47.2a.5.5 0 01-.41.58z"
              style={{
                transformOrigin: "244.172px 37.1013px",
              }}
              id="prefix__eljfm6xlai7nq"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M224.15 68.32a.51.51 0 01-.46-.3l-17.28-38.79a.5.5 0 11.91-.4l17.29 38.78a.49.49 0 01-.26.66.46.46 0 01-.2.05z"
              style={{
                transformOrigin: "215.499px 48.4px",
              }}
              id="prefix__el533moqu1n9"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M203 81.34a.51.51 0 01-.39-.18l-21.42-26.47a.51.51 0 01.08-.71.5.5 0 01.7.08l21.45 26.47a.5.5 0 01-.07.7.5.5 0 01-.35.11z"
              style={{
                transformOrigin: "192.307px 67.6069px",
              }}
              id="prefix__elyujtvs0ff4"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M186 99.39a.46.46 0 01-.29-.1l-35.84-26a.5.5 0 11.59-.81l35.84 26a.51.51 0 01.11.7.49.49 0 01-.41.21z"
              style={{
                transformOrigin: "168.083px 85.8866px",
              }}
              id="prefix__elzc30vfle35"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M174.23 121.23a.57.57 0 01-.18 0l-35.24-13.51a.51.51 0 01-.28-.65.49.49 0 01.64-.29l35.24 13.51a.51.51 0 01.28.65.48.48 0 01-.46.29z"
              style={{
                transformOrigin: "156.61px 113.992px",
              }}
              id="prefix__elffaukq2yfve"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M168.5 145.37h-.05L126.88 141a.5.5 0 01-.45-.55.5.5 0 01.57-.45l41.58 4.36a.49.49 0 01.44.54.5.5 0 01-.52.47z"
              style={{
                transformOrigin: "147.725px 142.683px",
              }}
              id="prefix__elb7dhe6dz0t8"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M118.47 178.23a.5.5 0 01-.08-1l50.75-8.06a.5.5 0 01.58.42.51.51 0 01-.42.57l-50.75 8.06z"
              style={{
                transformOrigin: "143.827px 173.697px",
              }}
              id="prefix__elhiw2gqepm34"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M145 207.9a.5.5 0 01-.2-1l31.31-14a.5.5 0 11.41.91l-31.31 14a.52.52 0 01-.21.09z"
              style={{
                transformOrigin: "160.618px 200.376px",
              }}
              id="prefix__el7mwynmj7o8b"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M163.25 236.23a.51.51 0 01-.39-.19.5.5 0 01.08-.7l26.11-21.16a.5.5 0 01.63.77l-26.12 21.16a.47.47 0 01-.31.12z"
              style={{
                transformOrigin: "176.289px 225.163px",
              }}
              id="prefix__elgq2nijtbu6b"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M175.67 275.81a.46.46 0 01-.29-.1.51.51 0 01-.11-.7L207 231.3a.49.49 0 01.69-.11.5.5 0 01.12.7l-31.73 43.71a.49.49 0 01-.41.21z"
              style={{
                transformOrigin: "191.54px 253.452px",
              }}
              id="prefix__elk2q5shlw4ff"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M349.78 261.67a.5.5 0 01-.39-.18l-26.69-32.94a.51.51 0 01.07-.71.5.5 0 01.7.08l26.7 32.94a.5.5 0 01-.08.7.51.51 0 01-.31.11z"
              style={{
                transformOrigin: "336.433px 244.701px",
              }}
              id="prefix__eldb6ajxdp586"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M370.59 232.81a.47.47 0 01-.3-.1l-30.47-22.12a.5.5 0 11.59-.81l30.47 22.12a.51.51 0 01.11.7.49.49 0 01-.4.21z"
              style={{
                transformOrigin: "355.348px 221.247px",
              }}
              id="prefix__eletdkea9nss9"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M381.87 200.34a.57.57 0 01-.18 0l-30-11.5a.5.5 0 11.36-.93l30 11.49a.5.5 0 01-.18 1z"
              style={{
                transformOrigin: "366.901px 194.135px",
              }}
              id="prefix__elt98xcdd0imj"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M370.59 166.06l-13-1.36a.5.5 0 01-.44-.55.5.5 0 01.55-.45l13 1.36a.5.5 0 01.44.55.49.49 0 01-.55.45z"
              style={{
                transformOrigin: "364.145px 164.881px",
              }}
              id="prefix__elpzu4c8z75ui"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M356.89 139.9a.5.5 0 01-.49-.42.5.5 0 01.42-.57l26.67-4.24a.5.5 0 01.16 1L357 139.89z"
              style={{
                transformOrigin: "370.235px 137.282px",
              }}
              id="prefix__elbawgtobwve7"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M349.78 116.13a.5.5 0 01-.2-1L372.47 105a.5.5 0 01.41.91L350 116.09a.45.45 0 01-.22.04z"
              style={{
                transformOrigin: "361.159px 110.554px",
              }}
              id="prefix__elmtujdl90lyc"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M336.75 95a.5.5 0 01-.31-.89l20.86-16.9a.49.49 0 01.7.07.49.49 0 01-.07.7L337.07 94.9a.54.54 0 01-.32.1z"
              style={{
                transformOrigin: "347.184px 86.0472px",
              }}
              id="prefix__el18iqh0th2pk"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M318.71 78a.53.53 0 01-.3-.09.51.51 0 01-.11-.7L325 68a.51.51 0 01.7-.11.5.5 0 01.11.7l-6.69 9.22a.51.51 0 01-.41.19z"
              style={{
                transformOrigin: "322.057px 72.8988px",
              }}
              id="prefix__eln4i13nxctj"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M296.87 66.2a.57.57 0 01-.18 0 .5.5 0 01-.29-.64l12.14-31.67a.5.5 0 11.94.36l-12.15 31.63a.48.48 0 01-.46.32z"
              style={{
                transformOrigin: "302.941px 49.8869px",
              }}
              id="prefix__elr9vsqcqlhhm"
              className="prefix__animable"
              fill="#0b345a"
            />
          </g>
        </g>
        <g
          id="prefix__freepik--shine--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "182.418px 221.425px",
          }}
        >
          <path
            d="M172.14 208.83a.62.62 0 01-.82-.16l-.35-.49a3.11 3.11 0 00-4-.94l-.53.27a.61.61 0 01-.65-1l.49-.35a3.11 3.11 0 00.94-4l-.27-.53a.63.63 0 01.22-.81.61.61 0 01.82.16l.35.49a3.12 3.12 0 004 .94l.53-.27a.61.61 0 01.65 1l-.49.35a3.11 3.11 0 00-.94 4l.27.53a.6.6 0 01-.22.81zm-3.84-3.15a4.2 4.2 0 012.19.52 4.4 4.4 0 01.51-2.2 4.4 4.4 0 01-2.19-.52 4.4 4.4 0 01-.51 2.2z"
            style={{
              transformOrigin: "169.655px 204.823px",
            }}
            id="prefix__elf90apiijt67"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M197.47 241.46a3.94 3.94 0 111.75-3.14 4 4 0 01-1.75 3.14zm-3.7-5.53a2.88 2.88 0 00-.34.27 2.71 2.71 0 001.75 4.69 2.71 2.71 0 10.19-5.42 2.67 2.67 0 00-1.6.46z"
            style={{
              transformOrigin: "195.282px 238.183px",
            }}
            id="prefix__ele02hz1r79mv"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M175.07 234.82l-1.59 1.29a.62.62 0 01-.78-1l1.6-1.29a.61.61 0 01.78.95z"
            style={{
              transformOrigin: "173.881px 234.962px",
            }}
            id="prefix__eljrohl3clehi"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M178.08 236.6a.6.6 0 01-.86-.09l-1.29-1.59a.65.65 0 01.09-.87.62.62 0 01.87.1l1.29 1.59a.62.62 0 01-.1.86z"
            style={{
              transformOrigin: "177.056px 235.329px",
            }}
            id="prefix__elpq72pum4u8n"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M178.66 231.91l-1.6 1.29a.62.62 0 01-.86-.09.63.63 0 01.09-.87l1.59-1.29a.62.62 0 01.87.1.6.6 0 01-.09.86z"
            style={{
              transformOrigin: "177.479px 232.075px",
            }}
            id="prefix__elh2u7s3k4tt"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M175.18 233a.63.63 0 01-.87-.09l-1.29-1.6a.6.6 0 01.1-.86.62.62 0 01.86.09l1.29 1.6a.61.61 0 01-.09.86z"
            style={{
              transformOrigin: "174.145px 231.725px",
            }}
            id="prefix__elq9a6mzet9z"
            className="prefix__animable"
            fill="#0b345a"
          />
        </g>
        <g
          id="prefix__freepik--shine--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "369.747px 165.522px",
          }}
        >
          <path
            d="M364.56 182.28a.62.62 0 01.28.79l-.23.55a3.13 3.13 0 001.25 3.88l.51.31a.61.61 0 01-.56 1.09l-.55-.23a3.1 3.1 0 00-3.87 1.25l-.31.51a.63.63 0 01-.81.22.62.62 0 01-.29-.78l.23-.55a3.1 3.1 0 00-1.24-3.88l-.51-.31a.61.61 0 01.56-1.09l.55.23a3.1 3.1 0 003.87-1.25l.31-.51a.62.62 0 01.81-.23zm-.71 4.92a4.27 4.27 0 01-.69-2.14 4.21 4.21 0 01-2.14.69 4.41 4.41 0 01.69 2.15 4.32 4.32 0 012.14-.7z"
            style={{
              transformOrigin: "362.417px 186.465px",
            }}
            id="prefix__elxfvad5uav5p"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M369.7 140.69a3.94 3.94 0 11-3.59.13 4 4 0 013.59-.13zm-2.81 6a2.86 2.86 0 00.41.15 2.69 2.69 0 002.06-.24 2.76 2.76 0 001.29-1.63 2.71 2.71 0 10-5 .59 2.72 2.72 0 001.24 1.16z"
            style={{
              transformOrigin: "368.032px 144.263px",
            }}
            id="prefix__elf0n54d446r"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M379.17 164.8l1.85.9a.61.61 0 01.28.82.62.62 0 01-.82.28l-1.84-.9a.61.61 0 01-.29-.82.62.62 0 01.82-.28z"
            style={{
              transformOrigin: "379.826px 165.8px",
            }}
            id="prefix__el3g5l07b59wf"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M379.51 161.32a.63.63 0 01.28.83l-.9 1.84a.61.61 0 11-1.1-.54l.9-1.84a.61.61 0 01.82-.29z"
            style={{
              transformOrigin: "378.789px 162.796px",
            }}
            id="prefix__el1mkkidt5vez"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M375 162.78l1.84.9a.61.61 0 01.28.82.63.63 0 01-.82.29l-1.84-.9a.62.62 0 01.53-1.11z"
            style={{
              transformOrigin: "375.68px 163.797px",
            }}
            id="prefix__els4dj6nq2ch"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M377.48 165.48a.62.62 0 01.29.82l-.9 1.85a.62.62 0 01-1.11-.54l.9-1.84a.61.61 0 01.82-.29z"
            style={{
              transformOrigin: "376.775px 166.933px",
            }}
            id="prefix__elpski0g4ji9"
            className="prefix__animable"
            fill="#0b345a"
          />
        </g>
        <g
          id="prefix__freepik--shine--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "193.424px 79.0312px",
          }}
        >
          <path
            d="M172.94 91.13a.61.61 0 01.49.67l-.07.6a3.11 3.11 0 002.27 3.38l.58.16a.61.61 0 01-.24 1.2l-.59-.07a3.12 3.12 0 00-3.38 2.27l-.16.57a.61.61 0 01-1.2-.23l.07-.59a3.11 3.11 0 00-2.27-3.39l-.57-.16a.61.61 0 01-.44-.71.62.62 0 01.68-.49l.59.07a3.1 3.1 0 003.38-2.27l.16-.57a.62.62 0 01.7-.44zm.67 4.92a4.42 4.42 0 01-1.25-1.87 4.24 4.24 0 01-1.87 1.25 4.41 4.41 0 011.26 1.87 4.38 4.38 0 011.86-1.25z"
            style={{
              transformOrigin: "172.059px 95.7625px",
            }}
            id="prefix__el9m527debsnm"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M186.4 64.37a3.94 3.94 0 11-3.4 1.12 3.94 3.94 0 013.4-1.12zm-1 6.57a2.12 2.12 0 00.44 0 2.73 2.73 0 002.7-2.73 2.71 2.71 0 10-4.62 1.94 2.6 2.6 0 001.44.79z"
            style={{
              transformOrigin: "185.798px 68.2638px",
            }}
            id="prefix__el70cet82to7c"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M216.93 61.11l2 .35a.62.62 0 01.49.72.6.6 0 01-.71.49l-2-.35a.62.62 0 01-.5-.71.61.61 0 01.72-.5z"
            style={{
              transformOrigin: "217.816px 61.8901px",
            }}
            id="prefix__elsdwvi8obz4o"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M216.3 57.67a.63.63 0 01.5.71l-.36 2a.64.64 0 01-.71.5.61.61 0 01-.5-.71l.36-2a.6.6 0 01.71-.5z"
            style={{
              transformOrigin: "216.014px 59.2721px",
            }}
            id="prefix__el92dmtk8nv6v"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M212.38 60.3l2 .35a.61.61 0 01.5.71.62.62 0 01-.71.5l-2-.35a.62.62 0 01-.5-.72.62.62 0 01.71-.49z"
            style={{
              transformOrigin: "213.275px 61.0798px",
            }}
            id="prefix__elrb0mrhr5pn"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M215.49 62.22a.61.61 0 01.49.71l-.35 2a.6.6 0 01-.71.5.61.61 0 01-.5-.71l.35-2a.62.62 0 01.72-.5z"
            style={{
              transformOrigin: "215.2px 63.8258px",
            }}
            id="prefix__ellt2pzj7znpc"
            className="prefix__animable"
            fill="#0b345a"
          />
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--Character--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "106.573px 274.503px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--character--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "106.573px 274.503px",
        }}
      >
        <g
          id="prefix__freepik--Bottom--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "89.814px 324.763px",
          }}
        >
          <path
            d="M110.84 378.09c-.15-5.07.73-46.23.73-46.23l-20.09 12.5c3.2 22.58 5.81 33.22 6.15 37.13a4.3 4.3 0 01.14.8c.07 4.47 5.44 6.83 9.64 9.77a77.49 77.49 0 0011.35 6.83c3 1.41 9.19 1.48 9.93-.37-5.11-3.61-11-7.54-15.11-11.68-1.95-1.98-2.58-4.04-2.74-8.75z"
            style={{
              transformOrigin: "110.085px 365.895px",
            }}
            id="prefix__elm0tonclbsd"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M137.39 403.24c.26 0 .68 2.7-.72 3.87-1.61 1.34-6.37 3.57-12.7 2.87s-9.78-2.53-12.33-4.5-6.13-4.76-9-5.33c-2.66-.53-5.56-1.63-6.42-2.4s-.78-4.22-.78-4.22z"
            style={{
              transformOrigin: "116.548px 401.821px",
            }}
            id="prefix__elb7zbyu1jbll"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M97.46 380.29s-.44 0-.59.76-.37 3.72-.77 5.28a26.5 26.5 0 00-.52 8.39c.36 1.76 4.71 2.95 7.49 3.91a36 36 0 019 5.26 26.9 26.9 0 0013.39 4.56c6.29 0 10.35-1.63 11.58-3.78 1.53-2.66.29-4.18-7-7.27-1.37-.58-6.21-3.22-7.86-4.18A23.92 23.92 0 01112 382.48a2.61 2.61 0 00-1.06-1.41 2.46 2.46 0 00-1.4-.11 17.59 17.59 0 00-4.24.91c-1 .44-2.34 1-2.31 2.14a4.14 4.14 0 00.29 1.19c.09.24.16.56-.06.7s-.49 0-.68-.17a17.8 17.8 0 01-2-2.19 6.66 6.66 0 00-1.16-1.09 14.25 14.25 0 01-1.25-.75 2.34 2.34 0 01-.67-1.41z"
            style={{
              transformOrigin: "116.536px 394.37px",
            }}
            id="prefix__elpkwksjxq2u"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M131.27 397.91c-9.11.69-11.91 6-12.26 9.32a22.44 22.44 0 006.48 1.22c6.29 0 10.6-1.63 11.84-3.78 1.44-2.51.42-4.51-6.06-6.76z"
            style={{
              transformOrigin: "128.456px 403.18px",
            }}
            id="prefix__elwm5lpx0uy2"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M117.61 398.14a.51.51 0 01-.28-.09.41.41 0 01-.07-.59 11.05 11.05 0 018.2-3.16.43.43 0 01.4.46.43.43 0 01-.48.38A10.2 10.2 0 00118 398a.48.48 0 01-.39.14z"
            style={{
              transformOrigin: "121.513px 396.217px",
            }}
            id="prefix__elrvlq40iaz6"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M113.67 396a.52.52 0 01-.29-.09.4.4 0 01-.06-.59 11 11 0 018.19-3.16.43.43 0 01.4.46.43.43 0 01-.48.38 10.22 10.22 0 00-7.42 2.84.46.46 0 01-.34.16z"
            style={{
              transformOrigin: "117.564px 394.075px",
            }}
            id="prefix__elo7u23hekm5"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M110 393.59a.52.52 0 01-.29-.09.41.41 0 01-.07-.59 11 11 0 018.2-3.15.41.41 0 01.4.45.43.43 0 01-.48.38 10.22 10.22 0 00-7.42 2.84.46.46 0 01-.34.16z"
            style={{
              transformOrigin: "113.894px 391.67px",
            }}
            id="prefix__elpmqy6h7264b"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M106.42 391.16a.47.47 0 01-.28-.09.41.41 0 01-.08-.59c1.72-2.1 5.65-3.51 9-3.2a.43.43 0 01.4.46.46.46 0 01-.49.38c-3-.28-6.64 1-8.17 2.88a.44.44 0 01-.38.16z"
            style={{
              transformOrigin: "110.715px 389.2px",
            }}
            id="prefix__el9b0g5zi9qsj"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M68.12 356.21L48.89 354c-1 12.19-.4 25.87-1.28 37.31-.16 2.15-1.83 16.67-1.44 21.17.58 6.76 9 6.65 9.87 2.72s3-21.08 3.18-22.83c.7-7.32 4.37-19.22 7.67-32.17.17-.6 1.11-3.37 1.23-3.99z"
            style={{
              transformOrigin: "57.1156px 385.955px",
            }}
            id="prefix__el796s54yoxgj"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M58.89 418.31c-.24 3.91-.88 6.51-2.36 8.81s-4.24 3-7.05 2.34-6.41-2.47-7.21-5.85a20.23 20.23 0 010-9.32z"
            style={{
              transformOrigin: "50.308px 421.993px",
            }}
            id="prefix__elfkz7tluwwiu"
            className="prefix__animable"
            fill="#263238"
          />
          <path
            d="M47.71 390c-1.16.08-1.5 5.34-2.17 10.61-.71 5.64-2.49 8-3.13 12.6-.73 5.29-.44 7.65 1.52 10.85s8.9 6.33 12.32 1.75c2.79-3.73 2.9-7.87 2.65-13.15a113 113 0 01.37-13.38c.23-4 1.15-8 .15-8.39-.08.59-.15 1.32-.24 1.89s-.17 2.59-.82 2.61a8.34 8.34 0 010-1.5 1.63 1.63 0 00-.31-1.27 2.15 2.15 0 00-1.29-.54c-1.14-.22-3.55-.31-4.71-.41a16.68 16.68 0 00-1.73-.07 4.54 4.54 0 00-1.47.2 1 1 0 00-.63.53 1.76 1.76 0 00-.06.61A4.38 4.38 0 0148 394c0 .16-.16.35-.32.31s-.19-.19-.19-.32c0-.64.08-1.1.11-1.84 0-.34.07-.81.08-1.16s.01-.7.03-.99z"
            style={{
              transformOrigin: "50.9603px 409.058px",
            }}
            id="prefix__eld9zp3gwkf"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M42.09 416.23c-.2 3.28 0 5.53 1.53 8 2 3.19 9.46 6.34 12.88 1.76 1.7-2.28 2.15-5 2.39-7.72-2.05-3.49-13.57-5.05-16.8-2.04z"
            style={{
              transformOrigin: "50.4577px 421.461px",
            }}
            id="prefix__el9b7fgxdgyk"
            className="prefix__animable"
            fill="#fafafa"
          />
          <path
            d="M55.92 412.56h-.14a17.84 17.84 0 00-10-1 .44.44 0 01-.51-.31.4.4 0 01.32-.49 18.45 18.45 0 0110.55 1 .4.4 0 01.2.54.45.45 0 01-.42.26z"
            style={{
              transformOrigin: "50.819px 411.482px",
            }}
            id="prefix__ely9km4vrh4fr"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M46.07 407.61a.42.42 0 01-.36-.28.39.39 0 01.27-.51c5.19-1.66 10.31.83 10.53.94a.39.39 0 01.18.54.44.44 0 01-.58.17s-5-2.44-9.86-.88a.55.55 0 01-.18.02z"
            style={{
              transformOrigin: "51.212px 407.385px",
            }}
            id="prefix__eld0gdqm31gn6"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M46.37 403.89a.42.42 0 01-.36-.27.4.4 0 01.26-.52A14 14 0 0157 404a.4.4 0 01.15.56.46.46 0 01-.59.14 13.28 13.28 0 00-10-.84.43.43 0 01-.19.03z"
            style={{
              transformOrigin: "51.5973px 403.591px",
            }}
            id="prefix__el40jn0ylz25j"
            className="prefix__animable"
            fill="#f0f0f0"
          />
          <path
            d="M46.72 399.72a.45.45 0 01-.36-.26.41.41 0 01.25-.53c5.35-1.89 10.61.9 10.83 1a.39.39 0 01.15.55.44.44 0 01-.58.15s-5.13-2.73-10.09-1a.69.69 0 01-.2.09z"
            style={{
              transformOrigin: "51.9913px 399.479px",
            }}
            id="prefix__elmldrx4e3co9"
            className="prefix__animable"
            fill="#ebebeb"
          />
          <path
            d="M63.37 220.25a9.22 9.22 0 01-1.86 4.44c-5.09 7.15-9.07 14-9.48 27C51 283.74 51.8 317 51.8 317c-.22 2.83-2.61 7.84-3.7 22.49-1 12.83-.62 30.4-.62 30.4s9.31 4.37 17.32 1.29c3.18-10.42 9.81-37.47 13.28-51.43 3.16-12.67 5.26-31.32 5.26-31.32l5.54 25.84a75.37 75.37 0 00.21 16.7c1 8.58 5 33.18 5 33.18s10.25 3 17.13-1.81c0 0 1.72-42.85 1.79-53.24.14-19.31 0-58.86-5.93-83.53a53 53 0 01-.38-5.74c-6.78 5.58-34.29 6.44-43.33.42z"
            style={{
              transformOrigin: "80.224px 296.055px",
            }}
            id="prefix__el9tlag725nj"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M74.09 229.32a.39.39 0 00-.45.27c-.37 1.49-.66 2.83-.93 4.13-1 4.69-1.72 8.07-5.26 11.71a12.39 12.39 0 01-8.93 3.57c1.53-9.59 4.78-17.25 9.94-23.58a.34.34 0 00-.07-.5.38.38 0 00-.52.07c-5.31 6.5-8.62 14.38-10.15 24.26v.05c0 .05 0 0 0 0a88.75 88.75 0 00-1 11.91c-.33 18-.83 45.3-1.11 52.45A51.46 51.46 0 0153.54 325c-.94 3.63-2 7.75-2.95 13.38-2.05 12.19-1 32.2-1 32.4a.37.37 0 00.38.34.37.37 0 00.36-.37c0-.2-1.05-20.15 1-32.26.94-5.6 2-9.7 2.94-13.32a52.53 52.53 0 002.12-11.51c.27-7.17.77-34.43 1.1-52.46a90.75 90.75 0 01.92-11.55h.39a13 13 0 009.2-3.78c3.69-3.78 4.43-7.25 5.45-12 .27-1.29.56-2.63.92-4.11a.35.35 0 00-.28-.44z"
            style={{
              transformOrigin: "61.8521px 297.984px",
            }}
            id="prefix__el2tvcp2ad9wu"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M47.42 365.89c2.74 2.58 14.22 3.95 18.42 1.69l-1.76 6.87s-2.73 1.69-8.83 1.14c-7.07-.64-7.83-2.9-7.83-2.9z"
            style={{
              transformOrigin: "56.63px 370.795px",
            }}
            id="prefix__eljg32i7ty9b"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M93.46 360.38c3.64 1.2 13.91.45 17.87-2l-.16 5.74s-2.23 2.15-8.32 2.79-8.57-1-8.57-1z"
            style={{
              transformOrigin: "102.395px 362.719px",
            }}
            id="prefix__eltjou32jyb"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M83.34 288.39l4-31.66a20 20 0 0016-7.71s.26 7.91-12.75 11.55l-4.79 29.19 3.08 24.47z"
            style={{
              transformOrigin: "93.3402px 281.625px",
            }}
            id="prefix__elqi5ehiieo6"
            className="prefix__animable"
            fill="#263238"
          />
        </g>
        <g
          id="prefix__freepik--Top--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "108.701px 183.602px",
          }}
        >
          <path
            d="M52.61 195.22c-2.21-1.15-3.72-2.13-5-4.46-1.52-2.75-2.14-5.69-.81-8.82a9.35 9.35 0 014-4.59 5.1 5.1 0 01-1.43-1.25 4.62 4.62 0 01-1-3 6.56 6.56 0 014.06-6.38c2.08-.88 4.15-1.37 5.64-3.24 1.26-1.59 1.07-4 .94-5.88-.18-2.46-.4-4.92-.53-7.38-.28-5.2-.79-12.41 4.94-18.59a9.49 9.49 0 015.34-2.89c2.15-4.93 7.13-7.45 11.38-8.55a33.27 33.27 0 0110.86-.72 18.53 18.53 0 0110.11 3.81 13.7 13.7 0 014.94 8.85 11.24 11.24 0 01-2 7.93 6.32 6.32 0 012.11 2.94c.54 2.55.14 5.65-4.07 7.69l-5.82 6.42a64 64 0 013.09 12.49 80.93 80.93 0 01.45 8.24c0 8.21-1.27 18-8.24 23.69-2 1.62-6.64 3-18.83.65s-19.27-6.51-20.13-6.96z"
            style={{
              transformOrigin: "76.2102px 161.372px",
            }}
            id="prefix__elile3dup4c1"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M131.65 203.55c7.77-5.19 10-6.62 10.94-8.61s.74-4 1.48-7.28a22.29 22.29 0 00.32-8.5c-.39-1.7 1.65-1.44 3.22.69s.93 3.3 1.27 5.32 1.26 1.82 2.53.63 7.31-7.21 9.43-8.91 3.53-1.23 4-.29c.29.54-.82 1.59-3.48 4.34s-5.43 5-5.24 5.21 2.9-2.32 6-4.74c2.81-2.22 4.43-3.3 6-3.1 1.73.23 1.78 1.55 1.28 1.92a76.11 76.11 0 00-6.62 5.22 32.64 32.64 0 00-3.49 3.3c.12.33 2.38-1.39 5.48-3.05 2.83-1.51 4.45-2.14 6-1.24.32.18.75.69.63 1-.29.67-2.6 1.71-4 2.54-2 1.21-2.22 1.24-3.69 2.23-1 .68-2.32 1.58-2.24 1.78s5.1-2 6.83-1.93c1.49.07 2.52.94 1.19 1.82s-8.62 5-11.38 6.75-5.79 4.18-8.39 6.14-14 9.8-14 9.8z"
            style={{
              transformOrigin: "151.535px 195.172px",
            }}
            id="prefix__el7l4rxn4ab0l"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M94.46 171.06c5 .45 9.12 2 13.22 7.28 3.55 4.58 16.68 26.64 16.68 26.64s8.5-3.66 11.67-5.36 6.68-3.52 7.36-7.72c0 0 9.31 10.4 7.38 12s-14.77 13.16-19.64 16.6c-6.37 4.48-8.48 5.79-12.93 2.48s-17.11-21.36-17.11-21.36z"
            style={{
              transformOrigin: "122.747px 197.946px",
            }}
            id="prefix__el1mefif6cxuf"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M94.28 171c5.7.29 8.94 1.57 12.77 5.93s17.43 27.81 17.43 27.81l5.41-2.6a13.3 13.3 0 001.28 7.8c2 3.82 6.52 5.46 6.52 5.46s-5.94 5.68-10.83 8.44-7.36 1.41-10.4-1.77-22.58-29.27-22.58-29.27z"
            style={{
              transformOrigin: "115.785px 198.166px",
            }}
            id="prefix__el25j4kga0rzy"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__elafjfsro6ntk">
            <path
              d="M94.28 171c5.7.29 8.94 1.57 12.77 5.93s17.43 27.81 17.43 27.81l5.41-2.6a13.3 13.3 0 001.28 7.8c2 3.82 6.52 5.46 6.52 5.46s-5.94 5.68-10.83 8.44-7.36 1.41-10.4-1.77-22.58-29.27-22.58-29.27z"
              style={{
                transformOrigin: "115.785px 198.166px",
              }}
              className="prefix__animable"
              id="prefix__eljm4ipi2jdma"
              opacity={0.2}
            />
          </g>
          <path
            d="M150.14 188.82c1.34 2.47-.39 6.23-2.29 8.3 2.92-1.9 4.71-4.89 2.29-8.3z"
            style={{
              transformOrigin: "149.561px 192.97px",
            }}
            id="prefix__elzcfrpgrei2"
            className="prefix__animable"
            fill="#f0997a"
          />
          <g id="prefix__elpo12oq6tyf">
            <path
              d="M124.48 204.7a12 12 0 00-5.79 10.58c-.67-3.66-1.11-8.55 4.81-12.36z"
              style={{
                transformOrigin: "121.397px 209.1px",
              }}
              className="prefix__animable"
              id="prefix__el59b2xy8l3y"
              opacity={0.2}
            />
          </g>
          <path
            d="M107.44 205.81c.27 4.72-.1 17.47-.1 17.47 1.61 11.81 2.67 19 2.67 19-20.91 11.16-52.56 3-56.53-1.57 2-10.35 8.37-19.69 7.21-25.23l-5-21.06s9.93-6.87 9.11-22.09a135.05 135.05 0 0113.58-1.64 100.83 100.83 0 0115.94.26c3.36 1.84 10.37 8 14.36 14.42s5.07 13.84-1.24 20.44z"
            style={{
              transformOrigin: "82.7014px 209.192px",
            }}
            id="prefix__ellhnlu9y6vwn"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__elnh28cvw7u2">
            <path
              d="M91.38 205.27s-5.45 4.82-12.16 2.92a11.24 11.24 0 01-8-7.57s-.22 7.53 8.21 9.56a10.86 10.86 0 0011.95-4.91z"
              style={{
                transformOrigin: "81.2997px 205.565px",
              }}
              className="prefix__animable"
              id="prefix__elmfo58f6suo9"
              opacity={0.1}
            />
          </g>
          <path
            d="M95.05 130.4c2.64 1.19 6.21 4.52 7.22 19.68.72 10.78-2.13 12.81-3.73 14-2.58 1.9-5.33 1.91-8.8 1.68l-.19 6.41s7.24 9.85 4 14.47a29.06 29.06 0 01-14.43-6.94 24.39 24.39 0 01-5.86-7l.24-13.85s-1.83 2.06-5.52-.49c-3-2.1-4.36-6-2.37-8.34a5 5 0 017.94.77s3.85-.1 4-7.3c0 0 5.69-.91 8.74-2.74 6.92-4.2 8.06-8.51 8.76-10.35z"
            style={{
              transformOrigin: "83.5285px 158.52px",
            }}
            id="prefix__elp0jj9efvpzk"
            className="prefix__animable"
            fill="#ffbda7"
          />
          <path
            d="M89.74 165.74c-5.44-.37-11.48-2.56-12.9-5.26a6 6 0 003.56 4.71c2.61 1.21 9.28 2.63 9.28 2.63z"
            style={{
              transformOrigin: "83.29px 164.15px",
            }}
            id="prefix__el6m5k5si3blh"
            className="prefix__animable"
            fill="#f0997a"
          />
          <path
            d="M87.69 145.92a1.6 1.6 0 01-1.32 1.8 1.52 1.52 0 01-1.83-1.2 1.6 1.6 0 011.32-1.8 1.53 1.53 0 011.83 1.2z"
            id="prefix__elqzansp0ye5"
            className="prefix__animable"
            style={{
              transformOrigin: "86.115px 146.221px",
            }}
          />
          <path
            d="M87.4 155.56l5.6 1.35a2.84 2.84 0 01-3.44 2.1 2.88 2.88 0 01-2.16-3.45z"
            style={{
              transformOrigin: "90.1636px 157.326px",
            }}
            id="prefix__el76rbrhfkcra"
            className="prefix__animable"
            fill="#b16668"
          />
          <path
            d="M87.87 156.69a3.89 3.89 0 00-.49 0 2.91 2.91 0 002.17 2.31 2.84 2.84 0 001.76-.14 3.8 3.8 0 00-3.44-2.17z"
            style={{
              transformOrigin: "89.345px 157.881px",
            }}
            id="prefix__elu4tkdupmqhk"
            className="prefix__animable"
            fill="#f28f8f"
          />
          <path
            d="M99.54 140.61l-3.54-.22a1.78 1.78 0 013.56.22z"
            id="prefix__elpu3w131mfms"
            className="prefix__animable"
            style={{
              transformOrigin: "97.7817px 139.663px",
            }}
          />
          <path
            d="M86 141.34l-3.16 1.71a1.79 1.79 0 01.73-2.45 1.7 1.7 0 012.43.74z"
            id="prefix__elfnv714bc83f"
            className="prefix__animable"
            style={{
              transformOrigin: "84.308px 141.7px",
            }}
          />
          <path
            d="M99.33 144.39a1.59 1.59 0 01-1.31 1.8 1.54 1.54 0 01-1.83-1.2 1.6 1.6 0 011.32-1.8 1.52 1.52 0 011.82 1.2z"
            id="prefix__el2z26urtvss4"
            className="prefix__animable"
            style={{
              transformOrigin: "97.7608px 144.689px",
            }}
          />
          <path
            style={{
              transformOrigin: "95.03px 148.92px",
            }}
            id="prefix__elmnivuhf1qz"
            className="prefix__animable"
            fill="#f0997a"
            d="M91.38 143.82l2.25 10.2 5.05-3.28-7.3-6.92z"
          />
          <g
            id="prefix__freepik--Arm--inject-203"
            className="prefix__animable"
            style={{
              transformOrigin: "81.5296px 203.495px",
            }}
          >
            <path
              d="M100.9 205c3.35-1.84 5-2.5 6.48-2.7s6.74-1.56 8.71-1.76c1.25-.13 1.47 1.86-.26 3-1.33.85-4.6 1.75-6.06 2.3s-4.56 3.39-4.56 3.39z"
              style={{
                transformOrigin: "108.989px 204.882px",
              }}
              id="prefix__elt1p90zf51i"
              className="prefix__animable"
              fill="#f0997a"
            />
            <path
              d="M51.52 183.5c1.74-6.15 4.45-9 13.33-10.94 7.43 7.2 2.05 24.93 2.05 24.93L63.74 216s21.4-.88 23.64-1.9 8.62-6.1 10.7-7.65c2.86-2 4.06-1.55 5.31-1.18 4.1 1.22 5 1.71 5.77 2.39a1.93 1.93 0 01.59 1.75c1.09.3 2.76.5 2.71 2.36a5.27 5.27 0 01-.14 1.47 1.24 1.24 0 01.67.52c.77 1.2-1.34 4.69-2.48 5.45a3.68 3.68 0 01-3.12.1c-1.1-.31-.42-1.38-.42-1.38l-1.59-.13c-3.75 1.93-4.6 6.7-9.25 7.12a30.56 30.56 0 00-5.65.29c-10.16 1.88-27.46 9.49-36.2 9-8.54-.47-7.57-4.9-7.87-10.11-.36-6.17 3.17-33.73 5.11-40.6z"
              style={{
                transformOrigin: "79.7698px 203.396px",
              }}
              id="prefix__ell4uuymh1ak"
              className="prefix__animable"
              fill="#ffbda7"
            />
            <path
              d="M64.76 172.34C59.1 173.42 54.5 175 52 180.71s-4.36 21.72-5 27.85-1.56 17.83-.61 21.4 4.39 4.7 8.3 4.69 12.42-2.34 15.77-3.63c0 0-2.44-1.81-2.77-7.27-.29-4.85 1.56-7.56 3.17-8.1l-6.91.24s3.17-16.48 4.32-22.21 2.07-18.31-3.51-21.34z"
              style={{
                transformOrigin: "58.4208px 203.495px",
              }}
              id="prefix__el8ukdc46ca1c"
              className="prefix__animable"
              fill="#0b345a"
            />
            <g id="prefix__el9mev59zof77">
              <path
                d="M64.76 172.34C59.1 173.42 54.5 175 52 180.71s-4.36 21.72-5 27.85-1.56 17.83-.61 21.4 4.39 4.7 8.3 4.69 12.42-2.34 15.77-3.63c0 0-2.44-1.81-2.77-7.27-.29-4.85 1.56-7.56 3.17-8.1l-6.91.24s3.17-16.48 4.32-22.21 2.07-18.31-3.51-21.34z"
                style={{
                  transformOrigin: "58.4208px 203.495px",
                }}
                className="prefix__animable"
                id="prefix__eld5s14712w59"
                opacity={0.2}
              />
            </g>
            <g id="prefix__elmiepd8pf2p">
              <path
                d="M64.3 214.13l-.3 1.76c-5.53.14-9.92 1.47-12.45 4.69 1.72-4.58 5.74-6 12.75-6.45z"
                style={{
                  transformOrigin: "57.925px 217.355px",
                }}
                className="prefix__animable"
                id="prefix__elm0g0m2mlg5h"
                opacity={0.2}
              />
            </g>
            <path
              d="M109.75 209.41l-4.83-1.71 4.82 1a2.06 2.06 0 01.01.71z"
              style={{
                transformOrigin: "107.348px 208.555px",
              }}
              id="prefix__el1c24fmx3e4b"
              className="prefix__animable"
              fill="#f0997a"
            />
            <path
              d="M112.32 213.24l-5.62-1.56 5.72.9a2.64 2.64 0 01-.1.66z"
              style={{
                transformOrigin: "109.56px 212.46px",
              }}
              id="prefix__el75ivr39khvn"
              className="prefix__animable"
              fill="#f0997a"
            />
            <path
              d="M111.21 215.65a1.8 1.8 0 01-.87.56 3.55 3.55 0 01-1 .2h.08c-.19.27-.4.54-.61.81l-.09-.17a1.19 1.19 0 01.88.36 1.5 1.5 0 01.39.81 1.77 1.77 0 00-.49-.7 1.14 1.14 0 00-.76-.25h-.23l.13-.18c.2-.28.4-.56.61-.82v-.05a5.48 5.48 0 001-.13 2.09 2.09 0 00.96-.44z"
              style={{
                transformOrigin: "109.86px 216.935px",
              }}
              id="prefix__el5rrspyhdnce"
              className="prefix__animable"
              fill="#f0997a"
            />
            <path
              d="M109.58 216.18a19.63 19.63 0 01-2.09-.15s-.1.4-.87 1a11.89 11.89 0 01-1.24.77l1.59.13a2.57 2.57 0 011.94-.72z"
              style={{
                transformOrigin: "107.48px 216.98px",
              }}
              id="prefix__elzh996mbe28d"
              className="prefix__animable"
              fill="#f0997a"
            />
          </g>
        </g>
      </g>
    </g>
    <g
      id="prefix__freepik--speech-bubble--inject-203"
      className="prefix__animable"
      style={{
        transformOrigin: "435.03px 183.847px",
      }}
    >
      <g
        id="prefix__freepik--speech-bubble--inject-203"
        className="prefix__animable"
        style={{
          transformOrigin: "435.03px 183.847px",
        }}
      >
        <g
          id="prefix__freepik--speech-bubble--inject-203"
          className="prefix__animable"
          style={{
            transformOrigin: "435.03px 183.847px",
          }}
        >
          <path
            d="M430.83 229.66l5.27-9.91-4.24-12.24V200l13 7.5v7.5l-5.58 9.67a.8.8 0 01-.38.33z"
            style={{
              transformOrigin: "437.845px 214.83px",
            }}
            id="prefix__elw6780he3pj"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__elm4v1wg2cksb">
            <path
              d="M430.83 229.66l5.27-9.91-4.24-12.24V200l13 7.5v7.5l-5.58 9.67a.8.8 0 01-.38.33z"
              style={{
                transformOrigin: "437.845px 214.83px",
              }}
              className="prefix__animable"
              id="prefix__eld9rgvtxiswj"
              opacity={0.2}
            />
          </g>
          <path
            d="M410.6 146.57a8.6 8.6 0 013.89-6.74l1.75-1a8.6 8.6 0 017.78 0l31.55 18.33a8.6 8.6 0 013.89 6.74v53.47a8.6 8.6 0 01-3.89 6.74l-1.75 1a8.6 8.6 0 01-7.78 0l-9.35-5.39-5.57 9.65a.83.83 0 01-1.51-.14l-5.88-17-9.24-5.45a8.58 8.58 0 01-3.89-6.78z"
            style={{
              transformOrigin: "435.03px 183.847px",
            }}
            id="prefix__el2weypnexrnv"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__elfwetayozr06">
            <path
              d="M410.6 146.57a8.6 8.6 0 013.89-6.74l1.75-1a8.6 8.6 0 017.78 0l31.55 18.33a8.6 8.6 0 013.89 6.74v53.47a8.6 8.6 0 01-3.89 6.74l-1.75 1a8.6 8.6 0 01-7.78 0l-9.35-5.39-5.57 9.65a.83.83 0 01-1.51-.14l-5.88-17-9.24-5.45a8.58 8.58 0 01-3.89-6.78z"
              style={{
                transformOrigin: "435.03px 183.847px",
              }}
              className="prefix__animable"
              id="prefix__elo0wzjy1dmfi"
              fill="#fff"
              opacity={0.3}
            />
          </g>
          <g id="prefix__elwueh261l3hq">
            <path
              d="M459.46 217.37a8.6 8.6 0 01-3.89 6.74l-1.75 1a8.69 8.69 0 01-7.12.31c1.84.7 3.23-.34 3.23-2.56v-53.47a8 8 0 00-1.14-3.83l9.53-5.5a7.91 7.91 0 011.14 3.84z"
              style={{
                transformOrigin: "453.08px 193.048px",
              }}
              className="prefix__animable"
              id="prefix__elq78c7k92fa9"
              fill="#0b345a"
              opacity={0.8}
            />
          </g>
          <g id="prefix__el6hjsq98iui">
            <path
              d="M410.72 145.47c.46-1.65 2-2.18 3.76-1.15L446 162.66a7.68 7.68 0 012.74 2.9l9.53-5.49a7.84 7.84 0 00-2.74-2.9L424 138.83a8.68 8.68 0 00-7.79 0l-1.76 1a8.61 8.61 0 00-3.73 5.64z"
              style={{
                transformOrigin: "434.495px 151.734px",
              }}
              className="prefix__animable"
              id="prefix__elldcgvq2mr2"
              fill="#fff"
              opacity={0.5}
            />
          </g>
        </g>
        <path
          id="prefix__freepik--Lightning--inject-203"
          style={{
            transformOrigin: "431.785px 185.95px",
          }}
          className="prefix__animable"
          fill="#fff"
          d="M430 161.97l9.72 25.78-8.35 1.43 2.6 20.75-10.12-26.68 8.32-1.82-2.17-19.46z"
        />
      </g>
    </g>
    <defs>
      <filter id="prefix__active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="prefix__hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="red" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0" />
      </filter>
    </defs>
  </svg>
);

export default VisionSVG;
